{
  "enums": {
    "cfdi": {
      "cancellation_reason": {
        "01": "Issued with errors, already replaced by another invoice",
        "02": "Issued with errors, with no replacement",
        "03": "The sale never happened",
        "04": "Itemized sale already covered by the global invoice"
      },
      "payment_form": {
        "01": "Cash",
        "02": "Nominative cheque",
        "03": "Electronic funds transfer",
        "04": "Credit card",
        "28": "Debit card",
        "99": "To be determined"
      },
      "payment_method": {
        "PPD": "Paid in instalments or deferred",
        "PUE": "Paid in a single payment"
      },
      "tax_regime": {
        "601": "General corporate regime",
        "603": "Non-profit legal entities",
        "605": "Wages, salaries and assimilated income",
        "606": "Leasing",
        "607": "Sale or acquisition of assets",
        "608": "Other income",
        "610": "Foreign residents with no permanent establishment in Mexico",
        "611": "Dividend income — partners and shareholders",
        "612": "Individuals with business and professional activity",
        "614": "Interest income",
        "615": "Prize income",
        "616": "No tax obligations",
        "620": "Production cooperatives that defer their income",
        "621": "Small taxpayer incorporation regime",
        "622": "Farming, livestock, forestry and fishing",
        "623": "Optional regime for groups of companies",
        "624": "Coordinated transport entities",
        "625": "Business income through technology platforms",
        "626": "Simplified trust regime — RESICO"
      },
      "usage": {
        "CP01": "Payments — complement to a deferred invoice",
        "G01": "Goods bought for the business",
        "G02": "Returns, discounts or rebates",
        "G03": "General expenses — the usual choice for a meal",
        "S01": "No tax effect — general public"
      }
    },
    "location": {
      "bill": {
        "status": {
          "awaiting_payment": "Awaiting payment",
          "cancelled": "Cancelled",
          "closed": "Closed",
          "open": "Open",
          "paid": "Paid"
        }
      },
      "bill_join_request": {
        "status": {
          "approved": "Approved",
          "canceled": "Canceled",
          "pending": "Pending",
          "rejected": "Rejected"
        }
      },
      "cancellation_reason": {
        "bill_closed_pending": "Still pending when the bill closed",
        "diner_left": "Diner left",
        "duplicate_order": "Duplicate order",
        "kitchen_cannot_prepare": "Kitchen cannot prepare it",
        "staff_error": "Staff error",
        "test_order": "Test order",
        "wrong_order": "Entered incorrectly"
      },
      "category": {
        "status": {
          "active": "Active",
          "forgiven": "Forgiven",
          "inactive": "Inactive"
        }
      },
      "channel": {
        "platform": {
          "didi_food": "DiDi Food",
          "rappi": "Rappi",
          "uber_eats": "Uber Eats"
        }
      },
      "channel_order": {
        "status": {
          "accepted": "Accepted",
          "failed": "Failed",
          "received": "Received",
          "rejected": "Rejected"
        }
      },
      "coupon_status": {
        "active": "Active",
        "exhausted": "Used up",
        "expired": "Expired",
        "revoked": "Revoked"
      },
      "courier": {
        "status": {
          "available": "Available",
          "off_shift": "Off shift",
          "on_delivery": "On delivery"
        }
      },
      "delivery": {
        "failure_reason": {
          "courier_incident": "Courier incident",
          "customer_refused": "Customer refused it",
          "nobody_home": "Nobody answered",
          "wrong_address": "Wrong address"
        },
        "status": {
          "assigned": "Assigned",
          "delivered": "Delivered",
          "failed": "Failed",
          "pending": "Unassigned",
          "picked_up": "On the way"
        }
      },
      "discount_kind": {
        "courtesy": "Courtesy",
        "fixed_amount": "Fixed amount",
        "percentage": "Percentage"
      },
      "discount_reason": {
        "kitchen_error": "Kitchen error",
        "loyalty_gesture": "Loyalty gesture",
        "manager_courtesy": "Manager courtesy",
        "marketing_promotion": "Promotion",
        "price_match": "Price match",
        "service_recovery": "Service recovery",
        "staff_meal": "Staff meal"
      },
      "discount_source": {
        "coupon": "Coupon",
        "manual": "Applied by a person",
        "promotion": "Automatic promotion"
      },
      "discount_status": {
        "applied": "Applied",
        "pending": "Awaiting authorization",
        "rejected": "Rejected",
        "superseded": "Replaced by a manual discount",
        "voided": "Voided"
      },
      "extra": {
        "status": {
          "active": "Active",
          "inactive": "Inactive",
          "sold_out": "Sold out"
        }
      },
      "feature": {
        "cash_register": "Cash register and shifts",
        "cfdi_invoicing": "CFDI invoicing",
        "daily_report_email": "Daily report email",
        "discounts": "Discounts and comps",
        "dynamic_invites": "Waiter QR invite",
        "external_channels": "Delivery apps",
        "inventory": "Inventory",
        "item_stock": "Per-dish stock counts",
        "kds": "Kitchen display",
        "loyalty": "Customers and loyalty",
        "multi_location": "Multiple locations",
        "own_delivery": "Own delivery",
        "pickup_orders": "Pickup orders",
        "promotions": "Promotions and coupons",
        "public_menu": "Public menu",
        "purchasing": "Purchasing and suppliers",
        "receipt_printing": "Ticket and receipt printing",
        "refunds": "Refunds",
        "sales_reports": "Sales reports",
        "tax_profiles": "Taxes",
        "tip_policies": "Tips",
        "waiter_call": "Call a waiter"
      },
      "feature_description": {
        "cash_register": "Opens and closes shifts, records cash in and out, and produces X and Z reports.",
        "cfdi_invoicing": "Stamps CFDI 4.0 invoices and lets your diner self-invoice.",
        "daily_report_email": "Emails your managers the previous day's sales every morning.",
        "discounts": "Applies discounts and comps at the table, with a record of who and why.",
        "dynamic_invites": "Lets a waiter generate a temporary QR to seat a diner. With this off, diners enter through the table's printed QR and you approve them.",
        "external_channels": "Receives Uber Eats, Rappi and DiDi Food orders on the same board.",
        "inventory": "Tracks supply stock, per-dish recipes and waste.",
        "item_stock": "Counts how many orders of each dish you can still sell today, and stops offering it once they run out.",
        "kds": "Shows tickets on a screen for the kitchen and the bar, with no paper.",
        "loyalty": "Keeps your regulars on file, collects stamps and takes reservations.",
        "multi_location": "Groups this location with others under a single organization.",
        "own_delivery": "Delivers with your own couriers and your own delivery zones.",
        "pickup_orders": "Lets your diners order ahead and pick the order up in person.",
        "promotions": "Schedules promotions by time of day and hands out coupon codes, with nobody having to apply them.",
        "public_menu": "Publishes your menu on an open page so search engines can find it.",
        "purchasing": "Records suppliers, purchase orders and the cost of each dish.",
        "receipt_printing": "Sends tickets to the kitchen and receipts to the diner from your printers.",
        "refunds": "Returns a payment with a required reason and a full audit trail.",
        "sales_reports": "Reviews sales, product mix and shift control.",
        "tax_profiles": "Choose your tax regime and the rates that apply at this location, and break them out on the receipt.",
        "tip_policies": "Sets the percentages suggested to the diner and how the tip is distributed.",
        "waiter_call": "Lets your diners call a waiter from their table."
      },
      "feature_group": {
        "expansion": "Growth",
        "finance": "Money and taxes",
        "operation": "Shift operation",
        "service": "Diner service",
        "supply": "Supplies and purchasing"
      },
      "invite": {
        "service_type": {
          "delivery": "Delivery",
          "eat_in": "Dine in",
          "pick_up": "Pickup",
          "take_out": "Take out"
        },
        "status": {
          "active": "Active",
          "exhausted": "Exhausted",
          "expired": "Expired",
          "revoked": "Revoked"
        }
      },
      "invoice": {
        "kind": {
          "bill": "Invoice for one bill",
          "global": "Daily global invoice",
          "payment_complement": "Payment complement"
        },
        "status": {
          "cancellation_pending": "Awaiting the receiver's acceptance",
          "cancelled": "Cancelled",
          "failed": "Stamping failed",
          "pending": "Awaiting stamp",
          "stamped": "Stamped"
        }
      },
      "item": {
        "station": {
          "bar": "Bar",
          "cashier": "Cashier",
          "dessert": "Dessert",
          "kitchen": "Kitchen"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive",
          "sold_out": "Sold out"
        }
      },
      "loyalty_entry": {
        "reason": {
          "expiry": "Expiry",
          "manual_adjustment": "Manual adjustment",
          "purchase": "Purchase",
          "redemption": "Redemption",
          "welcome_bonus": "Welcome bonus"
        }
      },
      "onboarding_requirement": {
        "address": "Address",
        "menu": "Menu",
        "operating_hours": "Operating hours",
        "payment_methods": "At least one enabled payment method",
        "payment_methods_confirmation": "Diner-facing payment methods confirmation",
        "stations": "Stations",
        "stripe_connect": "Stripe Connect ready to collect payments",
        "subscription": "Active subscription",
        "tables": "Tables"
      },
      "order": {
        "paid_via": {
          "cash": "Cash",
          "digital_in_app": "Digital in-app payment",
          "physical_card_terminal": "Physical card terminal"
        },
        "payment_status": {
          "locked": "In payment",
          "paid": "Paid",
          "unpaid": "Unpaid"
        },
        "service_type": {
          "delivery": "Delivery",
          "eat_in": "Dine in",
          "pick_up": "Pickup",
          "take_out": "Take out"
        },
        "status": {
          "cancelled": "Cancelled",
          "completed": "Completed",
          "in_progress": "In progress",
          "no_show": "No show",
          "pending": "Pending",
          "picked_up": "Picked up",
          "ready": "Ready",
          "ready_for_pickup": "Ready for pickup"
        }
      },
      "payment_attempt": {
        "payment_method": {
          "cash": "Cash",
          "digital_in_app": "Digital in-app payment",
          "physical_card_terminal": "Physical card terminal"
        },
        "status": {
          "canceled": "Canceled",
          "failed": "Failed",
          "pending": "Pending",
          "processing": "Processing",
          "requires_action": "Requires action",
          "succeeded": "Succeeded"
        }
      },
      "payment_provider_account": {
        "status": {
          "disabled": "Disabled",
          "pending_onboarding": "Pending onboarding",
          "ready": "Ready",
          "restricted": "Restricted"
        }
      },
      "payment_transaction": {
        "status": {
          "canceled": "Canceled",
          "checkout_ready": "Checkout ready",
          "failed": "Failed",
          "partially_refunded": "Partially refunded",
          "pending": "Pending",
          "processing": "Processing",
          "refunded": "Refunded",
          "requires_action": "Requires action",
          "succeeded": "Succeeded"
        }
      },
      "promotion_kind": {
        "fixed_amount": "Fixed amount",
        "percentage": "Percentage"
      },
      "promotion_scope": {
        "bill": "The whole bill",
        "categories": "Selected categories",
        "items": "Selected dishes"
      },
      "promotion_status": {
        "active": "Active",
        "archived": "Archived",
        "draft": "Draft"
      },
      "purchase": {
        "status": {
          "cancelled": "Cancelled",
          "draft": "Draft",
          "received": "Received"
        }
      },
      "purchase_cancel_reason": {
        "duplicate_purchase": "Duplicate purchase order",
        "no_longer_needed": "No longer needed",
        "ordered_by_mistake": "Ordered by mistake",
        "price_changed": "The price changed",
        "supplier_cannot_deliver": "Supplier cannot deliver"
      },
      "refund_reason": {
        "diner_changed_mind": "Diner changed their mind",
        "duplicate_charge": "Duplicate charge",
        "kitchen_error": "Kitchen error",
        "order_never_delivered": "Order never delivered",
        "price_correction": "Price correction",
        "service_error": "Service error",
        "wrong_item": "Wrong item"
      },
      "reopen_reason": {
        "additional_order": "The diner ordered something else",
        "closed_by_mistake": "Closed by mistake",
        "discount_correction": "A discount was missed",
        "payment_correction": "Payment correction"
      },
      "reservation": {
        "status": {
          "booked": "Booked",
          "cancelled": "Cancelled",
          "completed": "Completed",
          "no_show": "No show",
          "seated": "Seated"
        }
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "suspended": "Suspended"
      },
      "stock_movement": {
        "reason": {
          "count_correction": "Count correction",
          "purchase": "Purchase",
          "recipe_consumption": "Recipe consumption",
          "theft": "Theft",
          "transfer_out": "Transfer out",
          "waste": "Waste"
        }
      },
      "supply": {
        "unit": {
          "gram": "Grams",
          "kilogram": "Kilograms",
          "liter": "Liters",
          "milliliter": "Milliliters",
          "piece": "Pieces"
        }
      },
      "table": {
        "status": {
          "available": "Available",
          "disabled": "Unavailable",
          "occupied": "Occupied",
          "reserved": "Reserved"
        }
      },
      "tax_regime": {
        "mx": "Mexico — IVA and IEPS",
        "us": "United States — sales tax"
      },
      "user": {
        "role": {
          "bartender": "Bartender",
          "cashier": "Cashier",
          "cook": "Cook",
          "manager": "Manager",
          "waiter": "Waiter"
        }
      },
      "visit": {
        "status": {
          "active": "Active",
          "closed": "Closed"
        }
      }
    },
    "organization_membership": {
      "role": {
        "admin": "Administrator",
        "owner": "Owner"
      }
    },
    "payments": {
      "stripe_webhook_event": {
        "status": {
          "failed": "Failed",
          "processed": "Processed",
          "received": "Received"
        }
      }
    }
  },
  "notifications": {
    "staff": {
      "bill_closed": {
        "message": "Bill #%{bill_id} was closed.",
        "title": "Bill closed"
      },
      "bill_join_request": {
        "message": "There is a new request for bill #%{bill_id}.",
        "title": "Request to join bill"
      },
      "entry_requested": {
        "message": "%{name} is asking to be let in at %{table}.",
        "title": "Someone wants in at a table"
      },
      "entry_requested_no_table": {
        "message": "%{name} is asking to be let in.",
        "title": "Someone wants in at a table"
      },
      "item_stock_depleted": {
        "message": "%{item} is no longer available to order.",
        "title": "A dish ran out"
      },
      "item_stock_low": {
        "message": "You have %{count} of %{item} left.",
        "title": "A dish is running low"
      },
      "order_accepted": {
        "message": "Order #%{order_id} started preparation.",
        "title": "Order accepted"
      },
      "order_created": {
        "message": "Order #%{order_id} was registered.",
        "title": "New order"
      },
      "order_ready": {
        "message": "Order #%{order_id} is ready.",
        "title": "Order ready"
      },
      "payment_failed": {
        "message": "A payment failed for bill #%{bill_id}.",
        "title": "Payment failed"
      },
      "payment_succeeded": {
        "message": "A payment was confirmed for bill #%{bill_id}.",
        "title": "Successful payment"
      },
      "service_reactivated": {
        "message": "The location returned to active status.",
        "title": "Operation reactivated"
      },
      "service_suspension": {
        "message": "The location was suspended because the account is unpaid.",
        "title": "Operation suspended"
      }
    },
    "user": {
      "bill_closed": {
        "message": "Your bill #%{bill_id} is now closed. Thanks for visiting!",
        "title": "We closed your bill"
      },
      "entry_requested": {
        "message": "%{name} is asking to join your table.",
        "title": "Someone wants to join"
      },
      "join_request_updated": {
        "message": "Your request for bill #%{bill_id} changed to %{status}.",
        "title": "Request updated"
      },
      "order_created": {
        "message": "Your order #%{order_id} was registered.",
        "title": "Order received"
      },
      "order_status_changed": {
        "message": "Order #%{order_id} changed to %{status}.",
        "title": "Order status updated"
      },
      "payment_failed": {
        "message": "Payment for your bill #%{bill_id} could not be completed.",
        "title": "Payment failed"
      },
      "payment_succeeded": {
        "message": "Payment for your bill #%{bill_id} was confirmed.",
        "title": "Payment confirmed"
      },
      "waiter_call_acknowledged": {
        "message": "We took your call. Someone will be at your table shortly.",
        "title": "A waiter is on the way"
      }
    }
  },
  "ui": {
    "admin": {
      "events": {
        "actor": {
          "system": "System"
        },
        "headers": {
          "actor": "Author",
          "added": "Added",
          "location": "Location"
        }
      },
      "jobs": {
        "errors": {
          "invalid_arguments": "Invalid arguments for %{class_name}: %{message}",
          "invalid_json": "Invalid JSON arguments.",
          "job_not_allowed": "Job not allowed: %{class_name}",
          "json_shape": "JSON must be an object or an array.",
          "keywords_not_accepted": "%{class_name} does not accept keyword arguments. Expected: %{expected}",
          "missing_core_table": "Could not find the %{table} table. Check the Solid Queue connection and run queue migrations.",
          "missing_keywords": "Missing required arguments for %{class_name}: %{keywords}. Expected: %{expected}",
          "missing_tables": "Missing Solid Queue tables: %{tables}",
          "mixed_signature": "%{class_name} mixes positional and keyword arguments; it cannot be enqueued from this form. Signature: %{expected}",
          "positional_not_accepted": "%{class_name} does not accept positional arguments. Expected: %{expected}",
          "queue_database_unavailable": "Verify the queue database is configured and migrated.",
          "serialization_failed": "Could not serialize arguments: %{message}",
          "unknown_keywords": "Arguments not accepted by %{class_name}: %{keywords}. Expected: %{expected}",
          "wrong_arity": "%{class_name} expects %{expected} positional arguments, got %{given}."
        },
        "no_arguments": "No arguments",
        "no_message": "No message",
        "schema": {
          "blocked_executions": "Jobs blocked by concurrency limits.",
          "claimed_executions": "Running jobs claimed by an active process.",
          "failed_executions": "Failed jobs with serialized errors.",
          "jobs": "Created jobs and their final state (finished_at).",
          "pauses": "Queues paused manually.",
          "processes": "Workers and dispatchers with heartbeat.",
          "ready_executions": "Jobs ready to be picked up by a worker.",
          "recurring_tasks": "Recurring tasks declared in Solid Queue.",
          "scheduled_executions": "Jobs scheduled to run in the future."
        },
        "select_job": "Select a job."
      },
      "users": {
        "confirmed": "Confirmed",
        "last_activity": "Last activity"
      }
    },
    "app": {
      "name": "Menny"
    },
    "auth": {
      "admin": {
        "blurb": "Operations, payments and locations in one place.",
        "headline": "The whole system, in view."
      },
      "staff": {
        "blurb": "Sign in and pick up where you left off.",
        "headline": "The shift starts here."
      },
      "titles": {
        "admin_sign_in": "Sign in · Admin",
        "staff_invite": "Restaurant invitation",
        "staff_password_edit": "New password · Staff",
        "staff_password_new": "Reset your password · Staff",
        "staff_sign_in": "Sign in · Staff",
        "user_password_edit": "New password",
        "user_password_new": "Reset your password",
        "user_sign_in": "Sign in",
        "user_sign_up": "Create your account"
      },
      "user": {
        "blurb": "Your bill is still open where you left it.",
        "headline": "Order and pay from your table."
      }
    },
    "billing": {
      "location_status": {
        "in_production": "In production",
        "pending_configuration": "Pending configuration"
      },
      "seat_requested": "We are charging for this restaurant. It opens on its own once the payment clears.",
      "settings_updated": "Billing settings updated.",
      "stripe": {
        "charges_payouts_ready": "Charges and payouts enabled.",
        "confirmed": "Confirmed",
        "digital_requirements_missing": "Requirements are still missing for digital payments.",
        "no_connected_account": "No connected account",
        "no_enabled_methods": "No enabled methods",
        "none": "None",
        "not_connected": "Not connected yet",
        "pending": "Pending",
        "ready_to_charge": "Ready to charge",
        "requires_action": "Requires action",
        "restricted": "Restricted",
        "unconfigured": "Not configured"
      },
      "stripe_status_refresh_failed": "We couldn't refresh your Stripe status. Try again in a moment.",
      "stripe_status_refreshed": "We refreshed your Stripe account status."
    },
    "bills": {
      "label": "Bill #%{id}",
      "label_with_status_and_total": "Bill #%{id} · %{status} · %{total}"
    },
    "cfdi": {
      "errors": {
        "already_cancelled": "This invoice is already cancelled.",
        "already_invoiced": "This bill already has a live invoice. Cancel it before issuing another.",
        "attempts_exhausted": "We tried several times and it did not go through. Contact support so they can look at it with you.",
        "bill_not_paid": "Only a bill that has already been paid can be invoiced.",
        "cancel_not_allowed": "The SAT will not let this invoice be cancelled. If the deadline has passed you have to issue a credit note.",
        "cancel_reason_required": "Pick a cancellation reason from the SAT catalogue.",
        "cancel_requires_acceptance": "Your customer has to accept the cancellation. We have asked them and will tell you as soon as they answer.",
        "cancellation_rejected": "The SAT rejected the cancellation. Check the reason and try again.",
        "duplicate_document": "This bill already has a stamped invoice. Look for it in the history instead of issuing another.",
        "feature_off": "This restaurant does not have CFDI invoicing switched on.",
        "invalid_document": "The invoice carries data the SAT does not accept. Check the restaurant's fiscal details and try again.",
        "invalid_usage": "That CFDI usage cannot be chosen here.",
        "invoice_cancelled": "This invoice has already been cancelled, so it cannot be stamped.",
        "issuer_certificate_expired": "Your restaurant's seal certificate has expired. Renew it with the SAT and upload it to your stamping provider.",
        "month_closed": "The month this bill was paid in has closed, so it can no longer be invoiced individually.",
        "no_tax_profile": "You have not filled in your restaurant's fiscal details yet. Complete them to be able to invoice.",
        "not_retryable": "This invoice cannot be retried until you fix what stopped it.",
        "not_stamped": "This invoice has not been stamped yet, so there is nothing to cancel.",
        "nothing_to_invoice": "There is nothing to invoice on this bill.",
        "pac_insufficient_credit": "You have run out of stamps with your provider. Buy more to keep invoicing.",
        "pac_rate_limited": "We sent too many invoices at once. We will retry on our own in a few minutes.",
        "pac_timeout": "The stamping provider did not answer in time. We will retry on our own, you do not have to do anything.",
        "pac_unauthorized": "The stamping provider rejected your connection. Check your PAC key in the restaurant's fiscal details.",
        "pac_unavailable": "The SAT or your stamping provider is down. We will retry on our own, you do not have to do anything.",
        "receiver_rfc_unknown": "The SAT does not recognise the RFC you were given. Ask your customer for it again and check no letter is missing.",
        "substitute_required": "Enter the folio of the invoice that replaces this one.",
        "unbalanced_document": "The invoice figures do not add up. Contact support before trying again.",
        "unknown": "We could not stamp the invoice. Contact support with code %{code}.",
        "unmapped_tax": "We do not know which SAT tax %{names} is. Rename it to IVA or IEPS in the tax settings.",
        "unspecified": "We could not stamp the invoice and the provider did not say why. Try again in a few minutes."
      },
      "global_concepto": "General public sale — bill #%{bill_id}",
      "pac_environment": {
        "production": "Production",
        "sandbox": "Sandbox"
      }
    },
    "common": {
      "actions": {
        "back": "Back",
        "cancel": "Cancel",
        "close": "Close",
        "confirm": "Confirm",
        "delete": "Delete",
        "edit": "Edit",
        "save": "Save",
        "save_changes": "Save changes"
      },
      "bill": {
        "one": "bill",
        "other": "bills"
      },
      "false": "No",
      "free": "Free",
      "item": {
        "one": "product",
        "other": "products"
      },
      "item_count": {
        "one": "product",
        "other": "products"
      },
      "no_activity": "No activity",
      "no_message": "No message",
      "no_table": "No table",
      "no_waiter": "No waiter",
      "not_available": "—",
      "order": {
        "one": "order",
        "other": "orders"
      },
      "order_count": {
        "one": "order",
        "other": "orders"
      },
      "person": {
        "one": "person",
        "other": "people"
      },
      "table": {
        "one": "table",
        "other": "tables"
      },
      "true": "Yes",
      "unassigned": "Unassigned",
      "unknown": "Unknown"
    },
    "dashboard": {
      "quick_stats": {
        "active_orders": {
          "description": "Orders in preparation or delivery flow.",
          "label": "Active orders"
        },
        "open_bills": {
          "description": "Bills that are not closed yet.",
          "label": "Open bills"
        },
        "pending_payments": {
          "description": "Payment attempts in pending state.",
          "label": "Pending payments"
        },
        "ready_orders": {
          "description": "Orders ready for table service or pickup.",
          "label": "Ready to deliver"
        }
      }
    },
    "email_verification": {
      "code": {
        "change_email": "Use a different address",
        "code_label": "Verification code",
        "description": "We sent a %{length} digit code to %{email}.",
        "expiry_hint": "The code expires in %{minutes} minutes.",
        "no_email_hint": "Did not get it? Check your spam folder.",
        "resend": "Send another code",
        "submit": "Verify email",
        "submit_processing": "Verifying",
        "title": "Enter your code"
      },
      "details": {
        "change_email": "Change",
        "verified_badge": "Email verified"
      },
      "send": {
        "description": "We will send a code to confirm the address is yours. No account has been created yet.",
        "email_label": "Email address",
        "email_placeholder": "m@example.com",
        "submit": "Send code",
        "submit_processing": "Sending",
        "title": "Verify your email"
      }
    },
    "errors": {
      "admin_location_delete_failed": "Could not delete the location.",
      "admin_location_update_failed": "Could not update the location.",
      "already_registered_account": "You already have a registered account.",
      "anonymous_users_only": "Only anonymous users can complete registration",
      "array_attribute_required": "must be an array",
      "bill_already_splitting": "This bill is already being divided.",
      "bill_already_status": "The bill is already %{status}.",
      "bill_blocking_orders": {
        "one": "There is %{count} order in progress that cannot be abandoned.",
        "other": "There are %{count} orders in progress that cannot be abandoned."
      },
      "bill_has_orders": "This bill cannot be deleted because it has associated orders.",
      "bill_invite_same_location": "Bill and invite must belong to the same location",
      "bill_is_being_split": "The table is dividing the bill; items cannot be paid separately.",
      "bill_missing_for_location": "The bill does not exist or does not belong to the current location.",
      "bill_missing_or_not_open": "The bill does not exist or is no longer open.",
      "bill_must_be_closed_to_cancel": "The bill must be closed before cancellation.",
      "bill_must_be_closed_to_reopen": "The bill must be closed before reopening.",
      "bill_must_be_open_to_charge": "The bill must be open to charge.",
      "bill_must_belong_to_selected_table": "must belong to the selected table",
      "bill_no_unpaid_items": "The bill no longer has products pending payment.",
      "bill_not_available_to_charge": "The bill is not available for charging.",
      "bill_not_open_or_missing": "does not exist or is not open",
      "bill_payment_forbidden": "You do not have permission to charge this bill.",
      "bill_reopen_pending_payment": "cannot be reopened while there is a payment in progress",
      "bill_selected_closed": "The selected bill was already closed.",
      "bill_selected_unavailable": "The selected bill is not available.",
      "bill_selection_required": "could not be resolved: the table has more than one open bill. Settle them from Bills before adding items.",
      "bill_split_outstanding": "The table is dividing this bill. Cancel the split before closing it.",
      "bill_split_outstanding_cancel": "The table is dividing this bill. Cancel the split before cancelling it.",
      "bill_split_outstanding_reopen": "The table is dividing this bill. Cancel the split before reopening it.",
      "cancel_reason_invalid": "That cancellation reason does not exist.",
      "cannot_revoke_self": "You cannot revoke your own admin access.",
      "cash_amount_invalid": "Enter a valid amount, for example 1250.50.",
      "cash_amount_negative": "The amount cannot be negative.",
      "cash_amount_not_positive": "The amount must be greater than zero.",
      "cash_movement_kind_invalid": "That movement type does not exist.",
      "cash_movement_reason_invalid": "That movement reason does not exist.",
      "cash_movement_reason_not_manual": "That movement is not recorded by hand. Issue the refund from the bill so the full trail is kept.",
      "cash_register_permission_required": "You do not have permission to operate the register.",
      "category_delete_failed": "Could not delete the category.",
      "central_item_other_organization": "That dish does not belong to your organization.",
      "central_item_update_failed": "We could not save the central dish.",
      "central_price_failed": "We could not apply the price. No branch changed.",
      "cfdi_substitute_required": "is required when cancelling by substitution: enter the folio of the invoice that replaces this one",
      "channel_other_location": "That channel does not belong to this restaurant.",
      "channel_update_failed": "We could not update the channel.",
      "checkout_session_missing": "This payment has no active checkout session.",
      "counter_customer_name_required": "Enter the name of whoever is picking up the order.",
      "coupon_already_redeemed": "That coupon has already been used.",
      "coupon_delete_failed": "That coupon has already been used, so it cannot be deleted. Revoke it to stop it from working.",
      "coupon_expired": "That coupon has expired.",
      "coupon_line_already_discounted": "That bill already has a discount on it.",
      "coupon_not_found": "That code does not exist at this restaurant.",
      "coupon_not_redeemable": "That coupon can no longer be used.",
      "coupon_nothing_to_discount": "That coupon does not apply to anything in your cart.",
      "coupon_other_location": "That coupon belongs to another location.",
      "coupon_outside_window": "That coupon does not apply at this time of day.",
      "coupon_promotion_inactive": "The promotion behind that coupon is no longer active.",
      "coupon_redemption_count_max": "That coupon has already reached its redemption limit.",
      "coupon_revoked": "That coupon was cancelled.",
      "courier_delete_failed": "We could not delete the courier.",
      "courier_on_delivery": "You cannot change the shift of someone carrying an order.",
      "courier_other_location": "That courier does not belong to this restaurant.",
      "courier_update_failed": "We could not save the courier.",
      "current_password_invalid": "The current password is incorrect",
      "customer_insufficient_points": "The customer does not have that many points.",
      "customer_not_identifiable": "At least a name, phone, email or account is required.",
      "customer_other_location": "That customer does not belong to this restaurant.",
      "customer_points_invalid": "Points must be a positive number.",
      "delivery_illegal_transition": "That delivery is no longer in that state. Reload the screen.",
      "delivery_other_location": "That delivery does not belong to this restaurant.",
      "delivery_reason_required": "Tell us what happened so we can mark it failed.",
      "digital_checkout_only": "Only digital payments use Stripe Checkout.",
      "digital_payment_requires_stripe": "Stripe Connect must be ready to enable digital payments.",
      "digital_payment_resolution_forbidden": "Digital payments are resolved from Stripe.",
      "diner_has_other_active_bill": "The diner already has another active bill.",
      "diner_name_required": "Enter your name to join the table.",
      "discount_actor_required": "A manual discount has to carry the name of whoever applied it.",
      "discount_already_applied": "That item already has a discount. Remove it before applying another.",
      "discount_amount_not_positive": "The discount has to be greater than zero.",
      "discount_authorization_required": "Only a manager can authorize or reject a discount.",
      "discount_bill_cancelled": "This bill has been cancelled.",
      "discount_bill_not_open": "This bill is no longer open, so it cannot take a discount.",
      "discount_exceeds_line": "The discount cannot be larger than the item's price.",
      "discount_kind_invalid": "That discount type does not exist.",
      "discount_line_cancelled": "That item has been cancelled.",
      "discount_line_locked": "That item is held by a payment in progress.",
      "discount_line_other_bill": "That item is not on this bill.",
      "discount_line_paid": "That item has already been paid for.",
      "discount_not_pending": "That discount has already been resolved.",
      "discount_nothing_to_discount": "There is nothing left to discount on this bill.",
      "discount_other_location": "That bill belongs to another location.",
      "discount_payment_in_flight": "A payment is in progress: wait for it to finish before applying the discount.",
      "discount_permission_required": "You do not have permission to apply discounts.",
      "discount_promotion_required": "An automatic discount has to name the promotion it came from.",
      "discount_reason_invalid": "That discount reason does not exist.",
      "discount_split_settling": "This bill is being split and someone has already paid their share. The amount can no longer change.",
      "dish_unavailable": "That dish is no longer available.",
      "email_address_invalid": "Enter a valid email address.",
      "email_verification_required": "Verify your email before creating your account.",
      "empty_order_items": "You must add at least one product",
      "entry_request_already_resolved": "Someone already answered this request.",
      "entry_request_already_seated_elsewhere": "You already have an open table at %{table}. Close your account there before switching tables.",
      "entry_request_approve_forbidden": "You cannot authorize this entry.",
      "entry_request_expired": "Your request expired. You can ask again.",
      "entry_request_missing": "The entry request no longer exists.",
      "entry_request_not_rejected": "That request has not been rejected.",
      "entry_request_pending_cap_reached": "This table already has too many people waiting to be let in. Ask someone at the restaurant to help you in.",
      "entry_request_refused_cooldown": "You already got a no. Ask someone at the table to let you in.",
      "entry_request_requires_static_invite": "only applies to a printed table QR",
      "entry_request_table_unavailable": "This table is not in service right now.",
      "entry_request_too_many_attempts": "There have been too many requests with this code. Wait a few minutes or ask someone at the restaurant for help.",
      "expire_requires_digital": "Only digital payments have a session to expire.",
      "extra_attachable_type_invalid": "Extras can't be attached to that record",
      "extra_group_max_below_min": "Max selections can't be below min selections",
      "extra_location_mismatch": "Extra must belong to the same location as its group",
      "extra_rules_violated": "Selected extras don't satisfy the required choices",
      "extras_reorder_failed": "We couldn't save the new order. Reload and try again.",
      "feature_not_available": "That feature is not available for your restaurant.",
      "feature_unknown": "That feature does not exist.",
      "google_auth_failed": "We couldn't sign you in with Google. Please try again.",
      "hard_destroy_not_allowed": "This record cannot be permanently deleted; use soft deletion instead.",
      "idempotency_key_conflict": "The idempotency key is already associated with another bill.",
      "image_format_invalid": "must be a valid image format (JPEG, PNG, GIF, WebP)",
      "image_too_large": "must be less than 10MB",
      "invalid_credentials": "Incorrect email or password.",
      "invalid_modifiers": "contains invalid or unavailable options",
      "invalid_order_status": "That status does not exist.",
      "invalid_payment_method": "Invalid payment method.",
      "invalid_resolution_status": "invalid resolution status",
      "invalid_time_zone": "is not a valid time zone",
      "invalid_user": "Invalid user",
      "invite_exhausted": "The invite reached its usage limit.",
      "invite_expired": "The invite expired.",
      "invite_missing_or_invalid": "The invite does not exist or is no longer valid.",
      "invite_revoke_forbidden": "You do not have permission to revoke this invite.",
      "invite_revoked": "The invite was revoked.",
      "invite_unavailable": "The invite is no longer available.",
      "invite_used_count_max": "must be less than or equal to max_uses",
      "invoice_missing_for_location": "That invoice does not belong to this restaurant.",
      "item_delete_failed": "Could not delete the product.",
      "item_extras_update_failed": "Could not save the extra groups. Please try again.",
      "item_inactive": "is inactive",
      "item_inactive_unavailable": "is inactive",
      "item_not_found": "does not exist",
      "item_out_of_stock": "is out of stock",
      "item_out_of_stock_unavailable": "ran out of stock",
      "item_sold_out": "is marked as sold out",
      "item_sold_out_unavailable": "is marked as sold out",
      "item_stock_already_counted": "That item is already on the stock list.",
      "item_stock_other_location": "That item belongs to another location.",
      "item_stock_update_failed": "The stock count could not be updated.",
      "items_already_paid": "Some selected products have already been paid.",
      "items_locked_for_payment": "Some selected products are already in another payment in progress.",
      "join_bill_not_found": "Could not find the bill to join.",
      "last_manager_required": "At least one active manager is required",
      "last_manager_required_in_location": "At least one active manager is required in the location.",
      "launch_missing_requirements": "Missing requirements to go live: %{requirements}",
      "launched_location_requires_payment_method": "A live location must keep at least one payment method enabled.",
      "location_description_too_long": "Cannot be longer than %{max} characters.",
      "location_feature_unavailable": "That feature is not switched on for your restaurant.",
      "location_not_found": "Location not found",
      "location_not_live": "This restaurant is not available on Menny yet.",
      "location_slug_invalid": "Use lowercase letters, numbers, and hyphens, at least 3 characters long.",
      "location_slug_just_taken": "Someone else just claimed that address. Try a different one.",
      "location_slug_unavailable": "That address is not available. Choose another one.",
      "manage_bills_forbidden": "You do not have permission to manage bills.",
      "manager_access_required": "Only managers can access this section.",
      "modifiers_array": "must be an array",
      "no_authenticated_actor": "No authenticated actor to register the payment.",
      "no_open_shift": "Open the register before recording a cash or terminal payment.",
      "no_open_shift_for_movement": "Open the register before recording cash in or out.",
      "no_open_shift_for_order": "Open the register before taking an order.",
      "nothing_to_divide": "There is nothing left to pay on this bill.",
      "open_bill_required": "You need an open account to do this.",
      "operation_suspended": "Operation suspended because the account is unpaid.",
      "operation_suspended_billing": "The operation is suspended because the account is unpaid.",
      "order_bill_immutable": "cannot be changed once the order is created",
      "order_money_frozen": "A payment already covers this item: its price, quantity and discount are frozen.",
      "order_not_found": "We could not find that order.",
      "organization_admin_access_required": "Only owners and administrators can change the organization's details.",
      "organization_invite": {
        "already_member": "That person is already a member of the organization.",
        "invalid_email": "Check the email address, it does not look valid.",
        "invalid_role": "That access level does not exist.",
        "not_found": "That invitation no longer exists."
      },
      "organization_owner_access_required": "Only organization owners can manage its members.",
      "parent_id_required": "id is required",
      "parent_same_location": "must belong to the same location",
      "parent_self_reference": "cannot reference itself",
      "parent_type_invalid": "type is invalid",
      "parent_type_required": "type is required",
      "password_confirmation_mismatch": "Passwords do not match.",
      "password_reset_link_invalid": "The password reset link is invalid or has expired.",
      "payment_already_in_progress": "There is already a payment in progress for this bill.",
      "payment_attempt_not_pending": "This payment is no longer in progress.",
      "payment_permission_required": "You do not have permission to charge.",
      "pending_payment_cancel": "There is a pending payment attempt. Resolve it before cancelling the bill.",
      "pending_payment_close": "There is a pending payment attempt. Resolve it before closing the bill.",
      "pending_payment_reopen": "There is a pending payment attempt. Resolve it before reopening the bill.",
      "pickup_digital_payment_requires_availability": "The restaurant must confirm availability and ETA before digital pickup payment.",
      "pickup_eta_required": "must be set for pickup when the order is ready",
      "pickup_registered_account_required": "Pickup requires a registered account.",
      "pickup_split_not_supported": "Pickup does not support split bill in the MVP.",
      "pickup_status_only": "only applies to pickup orders",
      "pickup_tip_not_supported": "Pickup does not support tips in the MVP.",
      "pickup_unavailable": "This restaurant is not taking pickup orders.",
      "promotion_dates_ordered": "The end date cannot be earlier than the start date.",
      "promotion_delete_failed": "This promotion has already discounted real bills, so it cannot be deleted. Archive it to stop it from applying.",
      "promotion_other_location": "That promotion belongs to another location.",
      "promotion_percentage_ceiling": "The percentage cannot go above %{max}.",
      "promotion_target_other_location": "That dish or category belongs to another location.",
      "promotion_target_type_invalid": "A promotion can only point at dishes or categories.",
      "promotion_targets_update_failed": "We could not save the dishes or categories for this promotion.",
      "provider_in_use_for_location": "is already in use for this location",
      "purchase_already_received": "This purchase had already been received. Stock was not moved again.",
      "purchase_cancelled_cannot_receive": "This purchase is cancelled, so it can no longer be received.",
      "purchase_empty": "This purchase has no supplies: there is nothing to receive.",
      "purchase_invalid_cancel_reason": "Pick a cancellation reason from the list.",
      "purchase_line_location_mismatch": "must be a supply from the same location as the purchase",
      "purchase_lines_required": "Add at least one supply to the purchase.",
      "purchase_not_cancellable": "Only a draft purchase can be cancelled. If you already received it, record the movement in inventory.",
      "purchase_other_location": "That purchase belongs to another location.",
      "purchase_supply_other_location": "One of the supplies on this purchase belongs to another location.",
      "recipe_line_component_missing": "Pick a dish or an add-on for the recipe.",
      "recipe_line_location_mismatch": "The item, the extra and the supply must belong to the same location",
      "recipe_line_one_component": "A recipe line belongs to an item or to an extra, not to both",
      "recipe_line_other_location": "That recipe line belongs to another location.",
      "recipe_line_quantity_positive": "The recipe quantity has to be greater than zero.",
      "recipe_line_save_failed": "The recipe line could not be saved.",
      "refund_already_fully_refunded": "That payment has already been fully refunded.",
      "refund_amount_invalid": "Enter a valid amount, for example 250.00.",
      "refund_amount_not_positive": "The refund amount has to be greater than zero.",
      "refund_exceeds_charge": "You cannot return more than what is left on that payment.",
      "refund_missing_movement": "A cash refund has to be recorded as money leaving the drawer.",
      "refund_needs_open_shift": "Open the register before returning cash: the money comes out of today's drawer.",
      "refund_not_refundable": "That payment can no longer be refunded.",
      "refund_other_location": "That payment belongs to another location.",
      "refund_permission_required": "You do not have permission to issue refunds.",
      "refund_provider_missing": "That digital payment has no Stripe charge we can reverse.",
      "refund_reason_invalid": "That refund reason does not exist.",
      "registered_diners_only": "Create an account to use this section.",
      "reopen_reason_invalid": "That reopen reason does not exist.",
      "reservation_double_booked": "That table is already held at that time.",
      "reservation_ends_before_it_starts": "A reservation cannot end before it starts.",
      "reservation_not_seatable": "That reservation can no longer be seated.",
      "reservation_other_location": "That reservation does not belong to this restaurant.",
      "reservation_reason_required": "Tell us why the reservation is being cancelled.",
      "reservation_table_other_location": "That table does not belong to this restaurant.",
      "schedule_period_times_equal": "must be different from the start time",
      "select_one_item_to_charge": "Select at least one product to charge.",
      "selected_order_ids_array": "must be an array",
      "service_fee_percentage_number": "must be a valid number",
      "service_fee_percentage_range": "must be between 0 and 100",
      "share_carries_no_items": "a share of a divided bill carries no items",
      "shift_actor_not_staff": "That person is not staff at this location.",
      "shift_already_open": "A shift is already open at this location.",
      "shift_closed": "The shift is already closed.",
      "shift_closed_is_final": "A closed shift can no longer be modified.",
      "shift_has_open_bills": {
        "one": "You cannot close the register with %{count} unsettled bill.",
        "other": "You cannot close the register with %{count} unsettled bills."
      },
      "shift_other_location": "That shift belongs to another location.",
      "shift_stock_count_duplicated": "That dish is counted twice. Reload the screen and try again.",
      "shift_stock_count_invalid": "Enter a valid count: a whole number of 0 or more.",
      "shift_stock_count_unknown": "That dish is not in this location's stock list.",
      "shift_stock_counts_incomplete": "Confirm every dish's count before opening the register.",
      "shift_stock_update_needs_open_shift": "Open the register before correcting stock during service.",
      "split_cancel_staff_only": "Only staff can cancel a split that already has payments.",
      "split_fully_claimed": "This split is already covered.",
      "split_not_active": "This split is no longer active.",
      "split_payer_count_too_low": "The bill must be divided among at least 2 people.",
      "staff_member_delete_failed": "Could not delete the staff member.",
      "static_invite_never_expires": "must be empty on a static invite",
      "stock_adjustment_count_matches_balance": "Your count matches what we already had, so there is nothing to correct.",
      "stock_adjustment_note_required": "This reason needs a note explaining what happened.",
      "stock_adjustment_quantity_invalid": "Enter the quantity as a number.",
      "stock_adjustment_quantity_negative": "The quantity cannot be negative.",
      "stock_adjustment_quantity_not_positive": "The quantity has to be greater than zero.",
      "stock_adjustment_unknown_reason": "Pick a reason from the list.",
      "stripe_not_ready_for_location": "Stripe Connect is not ready to charge at this location.",
      "stripe_signature_invalid": "Invalid signature.",
      "stripe_webhook_secret_missing": "Stripe webhook secret is not configured.",
      "subscription_already_active": "This account already has an active subscription.",
      "supplier_delete_failed": "This supplier already has purchase orders, so it cannot be deleted. Deactivate it so it stops appearing when a purchase is entered.",
      "supplier_other_location": "That supplier belongs to another location.",
      "supply_delete_failed": "This supply already has movements or is used by a recipe, so it cannot be deleted. Remove it from the recipes if you no longer need it.",
      "supply_other_location": "That supply belongs to another location.",
      "supply_unit_locked": "The unit can no longer be changed because this supply has movements: changing it would reinterpret its whole history.",
      "supply_update_failed": "The supply could not be updated.",
      "table_action_invalid": "The table action is invalid.",
      "table_action_unavailable": "The action is not available for this table.",
      "table_already_has_open_bill": "The table already has an open bill. Close it before reopening this one.",
      "table_available": "The table is now available.",
      "table_available_create_new_bill": "The table is now available. You must create a new bill.",
      "table_context_required_for_menu": "You need to be seated at a table to view the menu.",
      "table_delete_failed": "A table with bills pending settlement cannot be deleted. Release the table first.",
      "table_required": "must exist",
      "table_same_location": "must belong to the same location",
      "tip_amount_invalid": "The tip amount cannot be negative.",
      "too_many_verification_codes": "You have requested too many codes. Try again later.",
      "try_again_later": "Try again later.",
      "user_already_in_location": "already belongs to the current location",
      "user_blank": "cannot be blank",
      "user_has_active_bill": "You already have an active bill at this location.",
      "verification_code_already_used": "That code was already used. Request a new one.",
      "verification_code_expired": "That code expired. Request a new one.",
      "verification_code_invalid": "That code is not right. Check it and try again.",
      "verification_code_locked": "Too many attempts. Request a new code.",
      "verification_code_not_found": "We could not find a code for that address. Request a new one.",
      "visit_required": "You need to be at a restaurant to see this.",
      "waiter_call_requires_table": "You need to be seated at a table to call the waiter.",
      "waiter_call_unavailable": "This restaurant does not take waiter calls from the app."
    },
    "extras": {
      "rule_at_least": "Choose at least %{min}",
      "rule_exact": "Choose %{count}",
      "rule_optional": "Optional",
      "rule_optional_up_to": "Optional, up to %{max}",
      "rule_range": "Choose between %{min} and %{max}"
    },
    "flashes": {
      "admin_created": "Admin access granted successfully.",
      "admin_location_created": "Location created successfully.",
      "admin_location_deleted": "Location deleted.",
      "admin_location_feature_updated": "Feature availability updated.",
      "admin_location_updated": "Location updated successfully.",
      "admin_revoked": "Admin access revoked successfully.",
      "anonymous_session_started": "Session started.",
      "bill_cancelled": "Bill #%{id} cancelled.",
      "bill_closed": "Bill #%{id} closed. Total: %{total}.",
      "bill_reopened": "Bill #%{id} reopened.",
      "bill_split_cancelled": "The bill split was cancelled.",
      "bill_split_opened": "The bill will now be divided.",
      "business_hours_updated": "Business hours updated.",
      "cash_movement_recorded": "Cash movement recorded.",
      "category_created": "Category created successfully.",
      "category_deleted": "Category deleted successfully.",
      "category_updated": "Category updated successfully.",
      "central_item_created": "Dish added to the central menu.",
      "central_item_deleted": "Dish removed from the central menu. Branches keep it.",
      "central_item_updated": "Central dish updated.",
      "central_price_applied": "Price applied in %{updated} branches. %{skipped} have it pinned and did not change.",
      "channel_connected": "Channel connected.",
      "channel_disconnected": "Channel disconnected. Orders that already arrived are kept.",
      "coupon_created": "Coupon created.",
      "coupon_deleted": "Coupon deleted.",
      "coupon_revoked": "Coupon revoked. It can no longer be used.",
      "coupon_updated": "Coupon updated.",
      "courier_created": "Courier added.",
      "courier_deleted": "Courier deleted.",
      "courier_updated": "Courier updated.",
      "customer_created": "Customer added.",
      "customer_points_updated": "Points updated.",
      "delivery_assigned": "Delivery assigned.",
      "delivery_failed": "Delivery marked as failed.",
      "delivery_updated": "Delivery updated.",
      "discount_applied": "Discount applied.",
      "discount_authorized": "Discount authorized.",
      "discount_pending_authorization": "Discount recorded. A manager has to authorize it before it takes effect.",
      "discount_rejected": "Discount rejected. The bill stays at full price.",
      "discount_voided": "Discount removed.",
      "entry_request_approved": "Entry approved.",
      "entry_request_cleared": "Request cleared. They can ask again.",
      "entry_request_rejected": "Entry rejected.",
      "extra_created": "Add-on created successfully.",
      "extra_deleted": "Add-on deleted successfully.",
      "extra_group_created": "Add-on group created successfully.",
      "extra_group_deleted": "Add-on group deleted successfully.",
      "extra_group_updated": "Add-on group updated successfully.",
      "extra_updated": "Add-on updated successfully.",
      "extras_reordered": "Add-on order updated.",
      "guest_session_already_active": "You already have an active registered session.",
      "guest_session_started": "Guest session started.",
      "invite_created": "Invite created successfully.",
      "invite_declined": "Invitation declined.",
      "invite_reused": "Active invite reused.",
      "invite_revoked": "Invite revoked.",
      "invoice_cancellation_requested": "We asked your customer to accept the cancellation. We will tell you as soon as they answer.",
      "invoice_cancelled": "Invoice cancelled.",
      "invoice_requested": "Invoice requested. We will tell you as soon as the SAT stamps it.",
      "item_created": "Product created successfully.",
      "item_deleted": "Product deleted successfully.",
      "item_marked_sold_out": "Product marked as sold out.",
      "item_reactivated": "Product reactivated.",
      "item_stock_created": "You started counting this dish.",
      "item_stock_deleted": "You stopped counting this dish.",
      "item_stock_updated": "Stock updated.",
      "item_updated": "Product updated successfully.",
      "locale_updated": {
        "description": "Your language preference has been saved.",
        "header": "Language updated"
      },
      "location_configuration_updated": "Configuration updated.",
      "location_created": "Location created successfully.",
      "location_feature_updated": "Feature updated.",
      "location_joined": "Successfully joined the restaurant.",
      "location_launched": "Location is live.",
      "location_public_menu_slug_updated": "Public menu link updated.",
      "location_taxes_updated": "Taxes updated.",
      "location_tips_updated": "Tips updated.",
      "location_updated": "Location updated successfully.",
      "order_sent": "We sent your order to the kitchen.",
      "order_updated": "Order updated successfully.",
      "orders_created": "Orders created successfully.",
      "organization_created": "Organization created. Now give it its first branch.",
      "organization_invite_accepted": "You are now part of the organization.",
      "organization_invite_declined": "You declined the invitation.",
      "organization_invite_revoked": "Invitation cancelled.",
      "organization_invite_sent": "Invitation sent.",
      "organization_settings_updated": "Organization details updated.",
      "password_created": "Done — your account now has its own password. You can keep signing in with Google or use it from now on.",
      "password_link_sent": {
        "create_description": "We sent the link to create your password to %{email}.",
        "header": "Check your email",
        "reset_description": "We sent the link to change your password to %{email}."
      },
      "password_reset_done": "The password has been reset.",
      "password_reset_instructions_sent": "Instructions to reset your password have been sent (if a user exists for that email address).",
      "password_updated": {
        "description": "Your password has been changed successfully.",
        "header": "Password updated"
      },
      "payment_attempt_created": "Payment attempt created.",
      "payment_attempt_reused": "Payment attempt reused by idempotency.",
      "payment_attempt_updated": "Charge updated.",
      "pickup_created": "Pickup created successfully.",
      "profile_updated": {
        "description": "%{name}'s profile was updated.",
        "header": "Profile updated"
      },
      "promotion_created": "Promotion created.",
      "promotion_deleted": "Promotion deleted.",
      "promotion_updated": "Promotion updated.",
      "promotion_window_updated": "Promotion schedule updated.",
      "purchase_cancelled": "Purchase cancelled.",
      "purchase_created": "Purchase saved as a draft. Receive it when the goods arrive.",
      "purchase_received": "Purchase received: stock and the average cost are updated.",
      "recipe_line_created": "Supply added to the recipe.",
      "recipe_line_deleted": "Supply removed from the recipe.",
      "recipe_line_updated": "Recipe quantity updated.",
      "refund_issued": "Refund recorded.",
      "reservation_cancelled": "Reservation cancelled. The table is free at that time.",
      "reservation_created": "Reservation booked.",
      "reservation_seated": "Party seated.",
      "settings_updated": {
        "description": "Your preferences have been saved.",
        "header": "Preferences updated"
      },
      "shift_closed": "Register closed. The Z report is ready.",
      "shift_opened": "Register opened.",
      "staff_member_created": "Staff member created successfully.",
      "staff_member_deleted": "Staff member deleted successfully.",
      "staff_member_updated": "Staff member updated successfully.",
      "staff_registration_created": "Account created successfully. Continue registering your restaurant.",
      "static_invite_created": "Printed QR created.",
      "static_invite_reused": "The printed QR already existed.",
      "static_invite_revoked": "Printed QR revoked. Print a new one before using the table.",
      "stock_adjustment_recorded": "Movement recorded in inventory.",
      "supplier_created": "Supplier created.",
      "supplier_deleted": "Supplier deleted.",
      "supplier_updated": "Supplier updated.",
      "supply_created": "Supply created.",
      "supply_deleted": "Supply deleted.",
      "supply_updated": "Supply updated.",
      "table_created": "Table created successfully.",
      "table_deleted": "Table deleted successfully.",
      "table_disabled": "Table disabled.",
      "table_form_updated": "Table updated successfully.",
      "table_occupied": "Table occupied.",
      "table_released": "Table released.",
      "table_reserved": "Table reserved.",
      "table_updated": "Table updated.",
      "tax_profile_updated": "Fiscal details saved.",
      "user_account_completed": "Account completed successfully. Welcome to your dashboard.",
      "user_account_created": "Account created successfully. Welcome to your dashboard.",
      "waiter_already_called": "We already let them know. A waiter is on the way.",
      "waiter_call_acknowledged": "Call answered.",
      "waiter_call_cancelled": "Done, we cancelled the call.",
      "waiter_call_not_pending": "That call was no longer active.",
      "waiter_called": "Done — a waiter is heading to your table."
    },
    "forms": {
      "labels": {
        "current_password": "Current Password",
        "email": "Email",
        "email_title": "Email",
        "name": "Name",
        "new_password": "New Password",
        "password": "Password",
        "password_confirmation": "Confirm Password",
        "password_confirmation_lower": "Password confirmation"
      },
      "placeholders": {
        "person_name": "John Doe",
        "staff_person_name": "Mary Smith"
      }
    },
    "landing": {
      "capabilities": {
        "groups": {
          "core": "Out of the box",
          "expansion": "More than one location",
          "finance": "Money",
          "operation": "Operation",
          "service": "Service"
        },
        "items": {
          "audit_log": {
            "description": "Every write leaves an event with its actor, timestamp, and previous state. Illegal transitions are blocked and recorded.",
            "title": "A log nobody can edit"
          },
          "cash_register": {
            "description": "Shifts, cash in and out, and the closing report with payment methods, refunds, discounts, and cancellations.",
            "title": "Cash drawer and Z report"
          },
          "discounts": {
            "description": "By item or by bill, with a reason catalog and two-tier authorization. Nobody gives anything away unsigned.",
            "title": "Discounts and comps"
          },
          "dynamic_invites": {
            "description": "For when the waiter would rather hand a group a short-lived code than point them at the table's paper.",
            "title": "Temporary QR for walk-ins"
          },
          "hybrid_orders": {
            "description": "The waiter from their phone and the diner from theirs add to the same bill. No duplicate tickets.",
            "title": "Hybrid ordering"
          },
          "item_split": {
            "description": "Everyone picks their own, or they divide equally among whoever decides. Whatever is paid locks immediately.",
            "title": "Item-level split"
          },
          "item_stock": {
            "description": "You type in how many go out today. At zero the dish stops selling and the team hears about it before it runs out.",
            "title": "Per-dish counts"
          },
          "kds": {
            "description": "For the bar or the line. A counter with no screen doesn't need one, so it arrives switched off.",
            "title": "Kitchen screen by station"
          },
          "multi_location": {
            "description": "The central price flows down to branches that haven't pinned their own, and each one is measured against the organization average rather than only summed.",
            "title": "Central menu and organization comparison"
          },
          "payment_methods": {
            "description": "Digital collection runs through Stripe Connect in your restaurant's name, with double-charge protection.",
            "title": "Cash, terminal, and digital payment"
          },
          "pickup": {
            "description": "With the ETA you set at confirmation, ready and picked-up states, and handling for whoever never showed.",
            "title": "Pickup orders"
          },
          "public_menu": {
            "description": "Publishing your prices to the open internet is your call. Nothing goes out until you ask for it.",
            "title": "A public address for your menu"
          },
          "refunds": {
            "description": "You define who may issue one and up to what amount, and every refund keeps a name and a reason.",
            "title": "Refunds with a reason"
          },
          "reports": {
            "description": "Sales by period that reconcile with the sum of your Z reports, plus the control report: discounts, cancellations, and refunds with a name and a reason.",
            "title": "Sales reports and product mix"
          },
          "roles": {
            "description": "The whole team works orders; only the manager touches menu, tables, users, billing, and configuration.",
            "title": "Roles with real limits"
          },
          "shared_bill": {
            "description": "The printed QR lives on the table. Whoever arrives asks to join, and someone on your team — or a diner already seated — approves.",
            "title": "A shared bill through the table's QR"
          },
          "taxes": {
            "description": "You pick your regime and your rates. The breakdown freezes at the charge, so the receipt says what was charged that day.",
            "title": "Tax regime"
          },
          "tips": {
            "description": "Diners can tip at any restaurant, and 0% is always offered with nothing preselected.",
            "title": "A tip that doesn't push"
          },
          "waiter_call": {
            "description": "The diner raises a hand from their phone and the table climbs the floor's attention list.",
            "title": "Call the waiter"
          }
        },
        "label": "What's included",
        "legend_optional": "Switch it on when you need it",
        "legend_shipped": "Works from day one",
        "title": "All of this comes in the plan. You switch on what you use."
      },
      "closing": {
        "description": "Set up at your own pace, unhurried and without a card. Payment is the last item on the list, and it is exactly the one that opens the doors.",
        "primary": "Create your restaurant",
        "secondary": "I already have an account",
        "title": "Set up your menu, your tables, and how you charge.",
        "trust": {
          "charges": {
            "description": "Idempotency on creation and on retry of the digital charge, and immediate locking of whatever is already paid.",
            "title": "Never charge twice"
          },
          "isolation": {
            "description": "Every record is tied to its location, and the three domains are separated by host, not by a permission somebody can forget.",
            "title": "Nobody sees what isn't theirs"
          },
          "orders": {
            "description": "If the internet wobbles, service keeps going. A stale screen is survivable; a lost order is not.",
            "title": "Never lose an order"
          }
        }
      },
      "footer": {
        "diners": "I'm a diner",
        "directory": "Directory",
        "staff": "Sign in to my restaurant",
        "tagline": "Table service, payments, and control for restaurants with table service."
      },
      "hero": {
        "badge": "Restaurant software",
        "description_after": ", from a phone, a tablet, or a computer.",
        "description_before": "Diners order and pay from their own phone, and the order lands straight on the station that prepares it. Your waiter stops transcribing tickets and handles what actually needs a person. ",
        "description_highlight": "All in the browser",
        "note": "Set up at your own pace. Your location opens on its own the moment the first payment lands.",
        "primary_cta": "Create your restaurant",
        "secondary_cta": "See what's included",
        "title": "Nobody waits to order. Nobody waits for the check."
      },
      "hero_bill": {
        "chip": {
          "subtitle": "without calling a waiter",
          "title": "Ana ordered from her table"
        },
        "entry_note": "2 diners on this bill · Luis asked to join",
        "items": {
          "aguachile": {
            "amount": "210.00",
            "name": "Shrimp aguachile",
            "quantity": "1",
            "who": "Luis"
          },
          "beer": {
            "amount": "65.00",
            "name": "Lager",
            "quantity": "1",
            "who": "Ana · paid and locked"
          },
          "jamaica": {
            "amount": "70.00",
            "name": "Hibiscus water",
            "quantity": "2",
            "who": "Luis · in the kitchen"
          },
          "pastor": {
            "amount": "96.00",
            "name": "Tacos al pastor",
            "quantity": "2",
            "who": "Ana"
          }
        },
        "live": "In service",
        "status_label": "Open bill",
        "table": "Table 12",
        "totals": {
          "due_label": "Still to collect",
          "due_value": "$376.00",
          "paid_label": "Already paid",
          "paid_value": "− 65.00",
          "subtotal_label": "Table bill",
          "subtotal_value": "441.00"
        }
      },
      "meta": {
        "description": "Self-service at the table, a connected kitchen, and control of your business. 100% web, paperless, with real indicators. From $1,200 a month per location.",
        "og_image_alt": "A guest ordering from their phone at the table, with the table's bill in view.",
        "title": "Menny — the system that runs your restaurant's whole shift"
      },
      "nav": {
        "audience": "Who it's for",
        "pricing": "Pricing",
        "product": "What's included",
        "self_service": "Self-service",
        "sign_in": "Sign in",
        "start": "Create your restaurant"
      },
      "pillars": {
        "insights": {
          "description": "Sales by period that reconcile with the sum of your Z reports, product mix with ABC classification, and the control report: discounts, cancellations, and refunds, each with a name and a reason. Exportable to CSV.",
          "title": "Indicators for your business"
        },
        "paperless": {
          "description": "A digital ticket to the kitchen and a digital receipt to the diner, with their closed-bill history. Nothing that fades on thermal paper or gets lost between two shifts.",
          "title": "Paperless"
        },
        "web": {
          "description": "It opens in the browser on a phone, a tablet, or a computer. Nothing to install, nothing to update, no hardware to buy. The waiter uses the phone already in their pocket.",
          "title": "100% web"
        }
      },
      "pricing": {
        "annual": {
          "amount": "$10,080",
          "badge": "Save 30%",
          "label": "Annual",
          "note_after": " a month.",
          "note_amount": "$840",
          "note_before": "Per location, plus VAT. Works out to ",
          "unit": "MXN / year"
        },
        "cta": "Create your restaurant",
        "description": "No modules billed separately and no tiers that unlock for more. What you see in the list above comes in the plan; each restaurant switches on what it uses.",
        "label": "Pricing",
        "monthly": {
          "amount": "$1,200",
          "label": "Monthly",
          "note": "Per location, plus VAT. No lock-in.",
          "unit": "MXN / month"
        },
        "notes": {
          "commission_after": " when paid at the counter.",
          "commission_before": "Pickup orders carry a service fee: ",
          "commission_middle": " when paid online and ",
          "commission_online": "7%",
          "commission_physical": "1%",
          "invoice": "One bill for the whole organization, whether you run one location or five. Add another and it is charged right away.",
          "suspension": "If a charge fails we never cut you off mid-service: suspension happens overnight, on your own restaurant's clock."
        },
        "title": "One price a month, with the whole product inside."
      },
      "self_service": {
        "body_first": "The order comes from the diner's phone and lands straight on the station that prepares it. The waiter stops being the middleman who walks, writes it down, and types it in again: they handle what genuinely needs a person — someone waiting to be let in, a table that rang, a ready order that has sat for six minutes.",
        "body_second": "And when the waiter does take the order, it goes on the same bill. There are no two systems, no two tickets, and no notepad somebody has to transcribe afterwards.",
        "kitchen": {
          "description": "Every product reaches its station with explicit states. No handwriting to decipher and no duplicate tickets.",
          "title": "Less noise in the kitchen"
        },
        "label": "Self-service",
        "title": "Diners order on their own. Your team does what actually needs a person.",
        "waiter": {
          "description": "No walking to take the order or to carry it to the kitchen. They walk when the attention list calls them.",
          "title": "Fewer trips for the waiter"
        }
      },
      "shift": {
        "description": "When the bill is the center, nothing gets lost between the order and the charge: the floor, the kitchen, and the register are all looking at the same object.",
        "label": "The shift",
        "steps": {
          "close": {
            "description": "With its full history. At the end of the shift the Z report reconciles with what the sales report says.",
            "stage": "It closes",
            "title": "The table frees up and everything stays written"
          },
          "order": {
            "description": "The waiter can correct a diner's selection before it is submitted. One table can carry several bills at once.",
            "stage": "They order",
            "title": "Diner and waiter, one single bill"
          },
          "pay": {
            "description": "By item or in equal parts. Totals freeze at the first attempt and whatever is paid locks for everyone.",
            "stage": "They pay",
            "title": "Everyone their own share"
          },
          "prepare": {
            "description": "Explicit states, no illegal jumps. If realtime degrades, the system polls instead of blocking service.",
            "stage": "It's prepared",
            "title": "The kitchen sees product and station"
          },
          "seated": {
            "description": "Nothing to install. They ask to join and somebody approves; the table raises its hand even when nobody is seated yet.",
            "stage": "They sit",
            "title": "They scan the table's QR"
          }
        },
        "title": "The life of a bill, start to finish."
      },
      "surfaces": {
        "attention": {
          "count": "3 pending",
          "rows": {
            "call": {
              "action": "On it",
              "age": "4 min",
              "detail": "Unanswered",
              "title": "Table 9 · called the waiter"
            },
            "entry": {
              "action": "Approve",
              "age": "2 min",
              "detail": "Scanned the table's QR",
              "title": "Table 4 · someone is waiting to join"
            },
            "ready": {
              "action": "Open table",
              "age": "6 min",
              "detail": "Aguachile, 2 waters",
              "title": "Table 2 · ready order not served"
            }
          },
          "title": "Needs attention"
        },
        "bill": {
          "due_label": "Your share",
          "due_value": "$280.00",
          "items": {
            "aguachile": {
              "amount": "210.00",
              "name": "Shrimp aguachile"
            },
            "jamaica": {
              "amount": "70.00",
              "name": "2 Hibiscus water"
            },
            "other": {
              "amount": "96.00",
              "name": "2 Tacos al pastor · Ana"
            }
          },
          "mine": "Mine",
          "pay": "Pay my share",
          "title": "Table bill"
        },
        "label": "Who it's for",
        "staff": {
          "description": "The floor is no longer a board to interpret: it is a list of what needs attention, ranked by urgency and carrying the age of each item. Below that, orders, bills, menu, staff, cash drawer, and reports for each location.",
          "host": "staff.menny.app",
          "title": "Your restaurant"
        },
        "title": "Your team and your diners, each in their own place.",
        "user": {
          "description": "They arrive through the table's QR, or find you in the directory when they order pickup. They order, see the shared bill, and pay from their phone, with nothing installed.",
          "host": "menny.app",
          "title": "Your diners"
        }
      }
    },
    "menu": {
      "add_to_order": "Add to order",
      "available_item": {
        "one": "available product",
        "other": "available products"
      },
      "item_fallback": "Product",
      "item_sold_out": "Product sold out",
      "no_category": "Uncategorized",
      "no_description": "No description",
      "no_items_available": "There are no available products in the menu.",
      "no_items_for_order": "There are no products available to order.",
      "no_items_for_table": "There are no products available to add to this table.",
      "no_parent_item": "No parent product"
    },
    "navigation": {
      "account_menu": "Account menu",
      "back_to_floor": "Back to the floor",
      "billing": "Billing",
      "branch": "Branch",
      "central_items": "Central menu",
      "channels": "Channels",
      "close_menu": "Close menu",
      "collapse_sidebar": "Collapse sidebar",
      "couriers": "Couriers",
      "customers": "Customers",
      "dark_theme": "Dark theme",
      "dashboard": "Activity",
      "deliveries": "Deliveries",
      "events": "Events",
      "expand_sidebar": "Expand sidebar",
      "go_to_management": "Go to management",
      "group_business": "Business",
      "group_catalog": "Catalog",
      "group_inventory": "Inventory and purchasing",
      "group_service": "Service",
      "home": "Home",
      "item_stocks": "Stock",
      "jobs": "Jobs",
      "light_theme": "Light theme",
      "locations": "Locations",
      "management": "Administration",
      "menu": "Menu",
      "monitoring": "Monitoring",
      "navigation_menu": "Navigation menu",
      "new_location": "New location",
      "new_organization": "New organization",
      "no_new_notifications": "You have no new notifications",
      "notifications": "Notifications",
      "notifications_unread": "Notifications, %{count} unread",
      "open_menu": "Open menu",
      "open_menu_unread": "Open menu, %{count} unread notifications",
      "operation": "Operation",
      "organization": "Branches",
      "payment_methods": "Methods",
      "payments": "Payments",
      "profile": "Profile",
      "promotions": "Promotions",
      "purchases": "Purchases",
      "realtime": "Real time",
      "recipes": "Recipes",
      "resilient_mode": "Resilient mode (polling)",
      "services": "Services",
      "staff": "Staff",
      "suppliers": "Suppliers",
      "supplies": "Inventory",
      "tables": "Tables",
      "tax_profile": "Fiscal details",
      "transactions": "Transactions",
      "users": "Users"
    },
    "orders": {
      "created_at": "Created: %{date}",
      "empty_order": "The order is empty",
      "no_current_orders": "No current orders.",
      "order_detail": "Order details",
      "start_preparation": "Start preparation"
    },
    "payments": {
      "methods": {
        "long": {
          "cash": "Cash",
          "digital_in_app": "In-app digital payment",
          "physical_card_terminal": "Physical terminal"
        },
        "short": {
          "cash": "Cash",
          "digital_in_app": "Digital payment",
          "physical_card_terminal": "Terminal"
        }
      },
      "stripe_checkout_product_name": "Bill #%{bill_id} · %{location_name}"
    },
    "react": {
      "components": {
        "features": {
          "menu": {
            "manage_menu_grid": {
              "category": "No category",
              "image": "No image",
              "soldout": "Sold out"
            },
            "menu_grid": {
              "category": "No category",
              "image": "No image",
              "soldout": "Sold out",
              "unavailable": "Unavailable"
            }
          },
          "profiles": {
            "guest": {
              "hint": "Create an account to keep your history and order pickup.",
              "name_hint": "Your name shows on the bill so your table knows who ordered what.",
              "name_label": "Your name",
              "register": "Create account",
              "title": "You're a guest"
            },
            "locale_selector": {
              "description": "Choose the language you want to use across the app.",
              "label": "Language",
              "save": "Save",
              "saved": "Language updated"
            },
            "password_form": {
              "cancel": "Cancel",
              "change_password": "Change Password",
              "confirm_password": "Confirm Password",
              "enter_password_current_new": "Enter your current password and the new password",
              "new_password": "New Password",
              "password_current": "Current Password"
            },
            "profile_form": {
              "cancel": "Cancel",
              "email": "Email",
              "information_staff": "Personal Information",
              "name": "Name",
              "save_changes": "Save Changes",
              "update_name_email": "Update your name and email address"
            },
            "profile_sidebar": {
              "account": "Account",
              "change_password": "Change password",
              "close_session": "Log Out",
              "configuration": "Settings",
              "current_orders": "Orders on this visit",
              "edit_profile": "Edit profile",
              "payment_methods": "Payment methods",
              "receipts": "Receipts"
            },
            "security_card": {
              "create_password": "Create password",
              "description": "How you get into your account.",
              "no_password": "Your account has no password of its own.",
              "sending": "Sending…",
              "signs_in_with": "You sign in with %{providers}",
              "title": "Security"
            },
            "settings": {
              "appearance": "Appearance",
              "description": "Manage your account preferences.",
              "theme_dark": "Dark",
              "theme_light": "Light",
              "theme_system": "System",
              "title": "Settings"
            },
            "time_zone_selector": {
              "description": "Choose the time zone used to display dates and times.",
              "label": "Time zone"
            }
          },
          "schedule": {
            "business_hours_form": {
              "closed": "Closed",
              "enable": "Enable",
              "enable_hint": "Quickly enable or disable business hours",
              "from": "From",
              "save": "Save",
              "timezone": "Timezone",
              "timezone_hint": "Set your timezone",
              "to": "To"
            }
          },
          "staff": {
            "manage_users": {
              "user_form": {
                "cancel": "Cancel",
                "confirmation_password": "Confirm password",
                "email": "Email",
                "mary_smith": "Mary Smith",
                "name": "Name",
                "role": "Role",
                "staff_example_com": "staff@example.com"
              }
            }
          }
        },
        "layouts": {
          "staff_context_switcher": {
            "current_context": "Where you are",
            "locations": "Branches",
            "manage_location": "Configure this location",
            "no_locations": "You do not work at any branch of this organization.",
            "switch_context": "Switch location or organization"
          },
          "staff_layout": {
            "bills": "Bills",
            "change_theme": "Change theme",
            "deliveries": "Deliveries",
            "go_profile": "Go to profile",
            "kds": "Kitchen",
            "new_order": "New Order",
            "no_tienes_notifications_new": "You have no new notifications",
            "orders": "Orders",
            "reports": "Reports",
            "reservations": "Reservations",
            "tables": "Tables",
            "till": "Till"
          },
          "staff_location_switcher": {
            "location_current": "Current location",
            "locations": "Locations"
          },
          "staff_onboarding_progress": {
            "launch": "Launch location",
            "next_step": "Next step: %{step}",
            "open_menu": "View setup progress",
            "pending_setup": "Setup pending",
            "steps_completed": "%{completed} of %{total} steps completed",
            "title": "Location setup"
          },
          "user_layout": {
            "footer_tagline": "Order, share, and pay without lines.",
            "no_tienes_notifications_new": "You have no new notifications"
          }
        },
        "ui": {
          "breadcrumb": {
            "breadcrumb": "breadcrumb",
            "more": "More"
          },
          "data_table": {
            "back_pages": "Back 5 pages",
            "boolean_false": "No",
            "boolean_true": "Yes",
            "clear_filter": "Clear filter",
            "clear_search": "Clear search",
            "clear_sort": "Clear sort",
            "columns": "Columns",
            "date_from": "From",
            "date_to": "To",
            "filter_column": "Filter by %{column}",
            "filters": "Filters",
            "forward_pages": "Forward 5 pages",
            "go_first_page": "Go to first page",
            "go_last_page": "Go to last page",
            "go_page_anterior": "Go to previous page",
            "go_page_next": "Go to next page",
            "loading": "Loading results",
            "next": "Next",
            "no_results": "No results.",
            "page": "Per page",
            "page_of": "Page %{page} of %{total}",
            "previous": "Previous",
            "results_page": "Results per page",
            "rows_selected": "%{selected} of %{total} row(s) selected",
            "search": "Search...",
            "sort_ascending": "Sort ascending",
            "sort_descending": "Sort descending"
          },
          "dialog": {
            "close": "Close"
          },
          "file_input": {
            "drop_image_here": "Drop your image here",
            "mb": "MB)",
            "remove_image": "Remove image",
            "select_image": "Select image",
            "single_image_uploader_max_size": "Single image uploader w/ max size (drop area + button) ∙",
            "svg_png_jpg_gif_max": "SVG, PNG, JPG or GIF (max.",
            "upload_image_file": "Upload image file"
          },
          "headers": {
            "back": "Back"
          },
          "inline_update": {
            "cancel": "Cancel",
            "save": "Save",
            "update_failed": "The change could not be saved",
            "updated": "Change saved"
          },
          "quantity_stepper": {
            "decrease": "Remove one",
            "increase": "Add one"
          },
          "sheet": {
            "close": "Close"
          },
          "sidebar": {
            "displays_mobile_sidebar": "Displays the mobile sidebar.",
            "sidebar": "Sidebar",
            "toggle_sidebar": "Toggle Sidebar"
          }
        }
      },
      "features": {
        "entry_requests": {
          "approve": "Approve",
          "reject": "Reject",
          "staff": {
            "approve": "Open the table",
            "approve_hint": "Confirm it only if you can see them at the table."
          }
        },
        "staff": {
          "bill_detail_drawer": {
            "bill": "Bill",
            "bill_empty": "This bill has no orders yet.",
            "bill_paid_manual_release": "The bill is now paid. The table is released manually from Tables once staff finishes cleaning.",
            "charge_cash": "Charge cash",
            "charge_terminal": "Charge terminal",
            "close_bill": "Close bill",
            "confirm_payment": "Confirm payment",
            "detail_orders": "Order details",
            "digital_payment_auto_confirmed": "This digital payment is confirmed automatically via Stripe. The UI will update when the webhook arrives.",
            "items_pay": "Unpaid products",
            "mark_failure": "Mark failure",
            "note": "Note:",
            "orders": "Orders",
            "payment_progress": "Payment in progress",
            "status_operational_payment_line": "Operational status and payment status per line.",
            "subtotal": "Subtotal",
            "text": "by",
            "tip": "Tip",
            "total": "Total",
            "updated": "Updated",
            "x": "x"
          },
          "cancellations": {
            "cancel": "Cancel",
            "confirm": "Confirm cancellation",
            "description": "Pick the reason and confirm. The cancellation is recorded under your name.",
            "reason_label": "Cancellation reason",
            "reason_placeholder": "Pick a reason",
            "submitting": "Cancelling…",
            "title": "Cancel"
          },
          "cash_drawer": {
            "closed_orders": "Open it to take orders and charge bills.",
            "closed_title": "The register is closed",
            "open_register": "Open the register"
          },
          "counter_order_workspace": {
            "customer": "Diner",
            "customer_hint": "The name is what gets called out when the order is ready. The phone is optional and is there to reach them.",
            "customer_locked_hint": "This ticket is already open under this name. Start a new ticket for another diner.",
            "customer_name": "Name",
            "customer_name_placeholder": "Under what name?",
            "customer_phone": "Phone",
            "customer_phone_placeholder": "Optional",
            "name_required": "Enter the diner's name before adding items.",
            "new_ticket": "New ticket",
            "title": "To-go order"
          },
          "discounts": {
            "applies_immediately": "The discount applies on confirm and the total drops right away.",
            "approve": "Authorize",
            "bill_discount_total": "Discounts",
            "blocked_already_discounted": "This item already has a discount.",
            "blocked_bill_cancelled": "This bill has been cancelled.",
            "blocked_bill_not_open": "This bill is no longer open.",
            "blocked_exceeds_line": "The discount is larger than the price.",
            "blocked_generic": "This item cannot take a discount right now.",
            "blocked_invalid_kind": "That discount type does not exist.",
            "blocked_invalid_reason": "That reason does not exist.",
            "blocked_line_cancelled": "This item has been cancelled.",
            "blocked_line_locked": "This item is held by a payment.",
            "blocked_line_paid": "This item has already been paid for.",
            "blocked_non_positive": "The discount has to be greater than zero.",
            "blocked_nothing_to_discount": "There is nothing left to discount.",
            "blocked_payment_in_flight": "A payment is in progress on this bill.",
            "blocked_split_settling": "This bill is being split and someone has already paid their share.",
            "cancel": "Cancel",
            "confirm": "Apply discount",
            "courtesy_notice": "A courtesy takes the whole line: the item goes to zero and does not count as a sale.",
            "description": "Pick the type and the reason. The discount is recorded under your name, with the original price still visible.",
            "kind_label": "Discount type",
            "kind_placeholder": "Pick a type",
            "line_discount": "Discount",
            "line_promotion": "Promotion",
            "open": "Discount",
            "open_bill": "Discount the bill",
            "original_price": "Original price",
            "pending_bill_scope": "the whole bill",
            "pending_empty": "No discounts are waiting for authorization.",
            "pending_line": "%{actor} requested %{detail}",
            "pending_title": "Discounts awaiting authorization",
            "reason_hint": "The reason goes into the location's log and is what gets counted later to explain why money was not collected.",
            "reason_label": "Discount reason",
            "reason_placeholder": "Pick a reason",
            "reject": "Reject",
            "requires_authorization": "This discount needs a manager to authorize it. It is recorded now and does not change the total until someone approves it.",
            "submitting": "Applying…",
            "supersede_amount_label": "Discount the table loses",
            "supersede_line_wholesale": "The %{names} promotion covers the whole bill. Applying this discount removes it from EVERY item on the table, not just this one.",
            "supersede_lines": "Applying this discount removes the %{names} promotion from this item.",
            "supersede_title": "This removes a promotion",
            "supersede_unnamed": "unnamed",
            "supersede_wholesale": "Applying this discount removes the %{names} promotion from the whole bill.",
            "title": "Apply a discount",
            "title_bill": "Discount the whole bill",
            "unknown_actor": "Not recorded",
            "value_label_fixed": "Amount off",
            "value_label_percentage": "Percentage off",
            "value_placeholder": "0.00",
            "void": "Remove discount"
          },
          "entry_request_panel": {
            "minutes_waiting": {
              "one": "%{count} min waiting",
              "other": "%{count} min waiting"
            },
            "rejected": "Rejected",
            "title": "Waiting to be let in",
            "undo": "Undo"
          },
          "inventory": {
            "actions_label": "Actions",
            "adjust_cancel": "Cancel",
            "adjust_confirm": "Record",
            "adjust_description": "A new row is written under your name. Nothing is rewritten.",
            "adjust_note_label": "Note",
            "adjust_note_placeholder": "What happened",
            "adjust_note_required": "This reason needs a note.",
            "adjust_open": "Record movement",
            "adjust_quantity_counted_hint": "What is on the shelf right now. We record the difference against what we had (%{balance}).",
            "adjust_quantity_counted_label": "How much you counted",
            "adjust_quantity_removed_hint": "How much is gone, as a positive number. We subtract it.",
            "adjust_quantity_removed_label": "How much left",
            "adjust_reason_label": "Reason",
            "adjust_reason_placeholder": "Pick a reason",
            "adjust_submitting": "Recording…",
            "adjust_title": "Record movement",
            "back": "Back to inventory",
            "cancel": "Cancel",
            "coverage_hint": "The shortages below only account for what the dishes that already have a recipe consume.",
            "coverage_label": "Recipe coverage",
            "coverage_value": "%{covered} of %{total} dishes have a recipe",
            "create": "Create supply",
            "creating": "Creating…",
            "delete": "Delete",
            "delete_blocked": "This supply already has history or is used by a recipe, so it cannot be deleted.",
            "delete_confirm": "Delete",
            "delete_description": "The supply is deleted. If it already has movements or a recipe uses it, it cannot be deleted.",
            "delete_title": "Delete supply",
            "empty_action": "Create the first supply",
            "empty_hint": "A supply is what the kitchen consumes. Enter the ones you want to track, then write the recipes that use them.",
            "empty_title": "No supplies yet",
            "form_description": "The name and the unit go together because the unit is locked as soon as the supply has its first movement.",
            "ledger_actor": "Who",
            "ledger_balance": "Balance after",
            "ledger_description": "Everything that moved this supply's balance, in order.",
            "ledger_empty": "This supply has no movements yet.",
            "ledger_immutable": "A movement is never edited or deleted: if something was recorded wrong, register a count correction and both rows stay visible.",
            "ledger_note": "Note",
            "ledger_open": "View movements",
            "ledger_open_full": "Open the supply record",
            "ledger_quantity": "Quantity",
            "ledger_quantity_in": "Quantity (%{unit})",
            "ledger_reason": "Reason",
            "ledger_system": "The system",
            "ledger_title": "Movements",
            "ledger_when": "When",
            "low_badge": "Below reorder point",
            "name_label": "Name",
            "name_placeholder": "Tomato",
            "new": "New supply",
            "new_title": "New supply",
            "pending_purchases_action": "View purchases",
            "pending_purchases_hint": "Stock goes up when you mark a purchase as received, not when you record it.",
            "pending_purchases_title": {
              "one": "You have 1 draft purchase",
              "other": "You have %{count} draft purchases"
            },
            "recipe_add": "Add",
            "recipe_add_ons_empty": "This restaurant has no add-ons yet.",
            "recipe_add_ons_hint": "Add-ons carry their own recipe. The order freezes which ones the diner chose, so without this the cheese and the guacamole are never drawn down.",
            "recipe_add_ons_title": "Add-ons",
            "recipe_dishes_title": "Dishes",
            "recipe_lines_count": "%{count} supplies",
            "recipe_no_dishes_action": "Go to the menu",
            "recipe_no_dishes_hint": "Recipes hang off the menu's dishes and add-ons.",
            "recipe_no_dishes_title": "No dishes on the menu yet",
            "recipe_no_lines": "No recipe",
            "recipe_no_supplies_action": "Go to inventory",
            "recipe_no_supplies_hint": "A recipe says how much of each supply a dish uses, so you need the supplies first.",
            "recipe_no_supplies_title": "Enter your supplies first",
            "recipe_quantity_placeholder": "Quantity",
            "recipe_quantity_updated": "Quantity updated.",
            "recipe_remove": "Remove",
            "recipe_supply_placeholder": "Pick a supply",
            "reorder_point_hint": "We flag the supply once stock reaches this amount. Leave it empty for no alert.",
            "reorder_point_label": "Reorder point",
            "reorder_point_placeholder": "No alert",
            "setup_action": "Write recipes",
            "setup_hint": "With no recipes nothing draws stock down, so the balance can only go up. Any shortage we showed you right now would be a data-entry mistake, not a supply that ran out.",
            "setup_title": "We cannot tell you what is missing yet",
            "short_badge": "Negative",
            "shortage_empty": "No supply is negative or below its reorder point.",
            "shortage_title": "Supplies to review",
            "stock_label": "Stock",
            "supply_updated": "Supply updated.",
            "unit_hint": "Everything is measured in this unit. Purchases, recipes and counts all use it, because the system never converts kilos into grams.",
            "unit_label": "Unit",
            "unit_locked": "This supply already has movements, so its unit can no longer be changed.",
            "unit_placeholder": "Pick the unit"
          },
          "invoices": {
            "bill_not_paid": "You will be able to invoice this bill once it is paid.",
            "cancel": "Cancel",
            "cancel_confirm": "Cancel invoice",
            "cancel_description": "The cancellation is sent to the SAT and recorded under your name. The motive comes from the SAT's catalog.",
            "cancel_open": "Cancel invoice",
            "cancel_reason_label": "Cancellation motive",
            "cancel_reason_placeholder": "Choose a motive",
            "cancel_title": "Cancel the invoice",
            "cancellation_pending_notice": "Your customer has not accepted the cancellation yet.",
            "confirm": "Issue invoice",
            "error_label": "What happened",
            "exhausted_notice": "We will not retry on our own any more. Contact support to look at it with you.",
            "folio_label": "Fiscal folio",
            "folio_pending": "No folio yet",
            "issue_description": "Copy the details exactly as your customer gave them. The invoice is issued to whoever gave them.",
            "issue_open": "Invoice",
            "issue_title": "Invoice this bill",
            "issued_at_label": "Stamped",
            "legal_name_label": "Legal name",
            "legal_name_placeholder": "As it appears on their tax record",
            "no_permission": "Only a manager can invoice.",
            "not_configured": "Enter the restaurant's fiscal details before invoicing this bill.",
            "not_configured_link": "Go to fiscal details",
            "postal_code_label": "Postal code",
            "postal_code_placeholder": "06000",
            "receiver_label": "Receiver",
            "rfc_label": "Customer RFC",
            "rfc_placeholder": "XAXX010101000",
            "status_pending": "We asked the SAT to stamp it. The folio appears here as soon as it answers.",
            "submitting": "Sending…",
            "substitute_hint": "The SAT requires it when you cancel by substitution.",
            "substitute_label": "Folio that replaces it",
            "substitute_placeholder": "UUID of the corrected invoice",
            "tax_regime_label": "Tax regime",
            "tax_regime_placeholder": "Choose your customer's regime",
            "title": "Invoice",
            "usage_label": "CFDI usage",
            "usage_placeholder": "Choose the usage"
          },
          "item_stocks": {
            "cancel": "Cancel",
            "create": "Start counting",
            "creating": "Saving…",
            "delete": "Stop counting",
            "delete_confirm": "Stop counting",
            "delete_description": "The dish goes back to depending only on whether it is active, with no stock limit.",
            "delete_title": "Stop counting this dish",
            "empty_action": "Count the first dish",
            "empty_hint": "Pick the dishes you want to track by stock and the system stops selling them once they run out.",
            "empty_title": "You are not counting any dish yet",
            "item_label": "Dish",
            "item_placeholder": "Pick a dish",
            "low_threshold_hint": "We warn you once stock reaches this amount. Leave it at 0 if you only want to know when it runs out.",
            "low_threshold_label": "Warn me from",
            "low_threshold_placeholder": "0",
            "new": "Count a dish",
            "new_title": "Start counting a dish",
            "quantity_label": "Stock",
            "quantity_placeholder": "0",
            "status_available": "Available",
            "status_depleted": "Out of stock",
            "status_low": "Running low",
            "table_actions": "Actions",
            "table_item": "Dish",
            "table_quantity": "Stock",
            "table_status": "Status",
            "table_threshold": "Warn from",
            "title": "Stock"
          },
          "menu_item_detail_drawer": {
            "modifiers_available": "Available extras",
            "soldout": "Sold out"
          },
          "new_order_form": {
            "add_less_item_order": "Add at least one product to the order.",
            "bill": "Bill:",
            "bill_2": "Bill",
            "cancel": "Cancel",
            "create_new_bill_table": "A new bill will be created for this table.",
            "decrease_quantity": "Decrease quantity",
            "extras": "Extras",
            "increase_quantity": "Increase quantity",
            "no_item_selected": "No product selected.",
            "no_items_available": "No products available to order.",
            "notes": "Notes",
            "notes_placeholder": "No onion, well done, sauce on the side…",
            "order_empty": "The order is empty",
            "quantity": "Quantity",
            "select_bill": "Select a bill",
            "select_bill_table": "Select a bill for the table.",
            "select_table": "Select a table",
            "select_table_before_order": "Select a table before creating the order.",
            "table": "Table",
            "type_service": "Service type",
            "view_order": "View order"
          },
          "order_detail_drawer": {
            "bill": "Bill",
            "customer": "Customer",
            "eta_pickup": "Pickup ETA",
            "eta_pickup_minutes": "Pickup ETA (minutes)",
            "example_10": "e.g. 10",
            "extras": "Extras",
            "min": "min",
            "notes": "Notes",
            "placed_at": "Received",
            "price": "Price",
            "quantity": "Quantity",
            "station": "Station",
            "table": "Table"
          },
          "orders_board": {
            "all_stations": "All",
            "bill": "Bill %{id}",
            "column_empty": "No orders",
            "delayed": "Delayed",
            "description": "Active orders. Longest wait at the top.",
            "empty_hint": "New orders land here, with the longest wait at the top.",
            "empty_title": "No active orders",
            "eta": "ETA: %{count} min",
            "just_placed": "just now",
            "minutes_short": "%{count} min",
            "new_order": "New order",
            "no_matches_hint": "Switch station or clear the delayed filter.",
            "no_matches_title": "No orders match",
            "note": "Note: %{note}",
            "only_delayed": "Delayed only",
            "open_detail": "Open order detail",
            "quantity": "Quantity",
            "service_type_description": "Pick how it will be served. Each one opens the screen it is taken on.",
            "service_type_dine_in": "Dine in",
            "service_type_dine_in_hint": "Pick the table and take the order from there.",
            "service_type_title": "Where is this order for?",
            "service_type_to_go": "To go",
            "service_type_to_go_hint": "Capture the diner and build the counter order.",
            "station_filter": "Filter by station",
            "status_filter": "Filter by status",
            "title": "Tickets",
            "waiting_time": "Waiting time"
          },
          "promotions": {
            "cancel": "Cancel",
            "coupon_cancel": "Cancel",
            "coupon_code_label": "Code",
            "coupon_code_placeholder": "SUMMER25",
            "coupon_create": "Create coupon",
            "coupon_delete": "Delete",
            "coupon_delete_confirm": "Delete",
            "coupon_delete_description": "Only a coupon nobody has redeemed can be deleted.",
            "coupon_delete_title": "Delete coupon",
            "coupon_expires_hint": "Leave it empty if it should never expire.",
            "coupon_expires_label": "Expires",
            "coupon_expires_never": "Never expires",
            "coupon_expires_on": "Expires on %{date}",
            "coupon_max_label": "Redemptions allowed",
            "coupon_new": "New coupon",
            "coupon_revoke": "Revoke",
            "coupon_revoke_confirm": "Revoke coupon",
            "coupon_revoke_description": "The code stops working immediately. The redemptions it already had stay on the record.",
            "coupon_revoke_reason_label": "Reason",
            "coupon_revoke_reason_placeholder": "Leaked on social media",
            "coupon_revoke_title": "Revoke coupon",
            "coupon_revoked_reason": "Reason: %{reason}",
            "coupon_used_hint": "It has already been redeemed, so it cannot be deleted. Revoke it to stop it from working.",
            "coupon_uses": "%{used} of %{max} redemptions",
            "coupons_description": "Codes a diner types to trigger this same promotion.",
            "coupons_empty": "This promotion has no coupons.",
            "coupons_open": "Coupons (%{count})",
            "coupons_title": "Coupons for this promotion",
            "create": "Create promotion",
            "dates_always": "No date limits",
            "dates_from": "From %{date}",
            "dates_range": "%{from} — %{to}",
            "dates_until": "Until %{date}",
            "delete": "Delete",
            "delete_confirm": "Delete",
            "delete_description": "This deletes the rule and the coupons that depend on it. A promotion that has already discounted real bills cannot be deleted: archive it instead.",
            "delete_title": "Delete promotion",
            "edit": "Edit",
            "edit_title": "Edit promotion",
            "empty_action": "Create the first promotion",
            "empty_hint": "A promotion is a rule that discounts on its own, with nobody standing there. Create the first one and turn it on once you have reviewed it.",
            "empty_title": "No promotions yet",
            "ends_on_label": "Ends",
            "form_description": "Set what it takes off, what it reaches and between which dates. It is created as a draft and changes no price until you turn it on.",
            "kind_label": "Discount type",
            "live_now": "Applying now",
            "max_discount_hint": "The most this rule may take off each time it applies. Leave it empty for no ceiling.",
            "max_discount_label": "Ceiling per application",
            "max_discount_placeholder": "No ceiling",
            "name_label": "Name",
            "name_placeholder": "Beer happy hour",
            "new": "New promotion",
            "new_title": "New promotion",
            "not_live_now": "Outside its window",
            "priority_hint": "When two promotions reach the same dish, the higher priority wins.",
            "priority_label": "Priority",
            "priority_summary": "Priority %{value}",
            "reach_bill": "The whole bill",
            "reach_categories": "%{count} categories",
            "reach_items": "%{count} dishes",
            "save": "Save changes",
            "scope_label": "Reach",
            "starts_on_label": "Starts",
            "status_label": "Status",
            "status_updated": "Promotion status updated.",
            "targets_categories_empty": "There are no categories on the menu yet.",
            "targets_categories_label": "Categories it reaches",
            "targets_items_empty": "There are no dishes on the menu yet.",
            "targets_items_label": "Dishes it reaches",
            "targets_selected": "%{count} selected",
            "value_label_fixed": "Amount off",
            "value_label_percentage": "Percentage off",
            "window_description": "The days and hours this rule applies in.",
            "window_enable": "Apply only during this schedule",
            "window_enable_hint": "Left off, the promotion applies at every hour inside its dates.",
            "window_open": "Schedule",
            "window_time_zone": "The schedule is read in the restaurant's time zone (%{zone}).",
            "window_title": "Promotion schedule"
          },
          "purchasing": {
            "back_to_purchases": "Back to purchases",
            "blocked_go_suppliers": "Go to suppliers",
            "blocked_no_suppliers_hint": "A purchase is always from someone. Create the supplier and come back here.",
            "blocked_no_suppliers_title": "Record a supplier first",
            "blocked_no_supplies_hint": "A purchase adds quantities to supplies that already exist. Create them in Supplies, with the unit you will count them in.",
            "blocked_no_supplies_title": "Record your supplies first",
            "cancel": "Cancel",
            "cancelled_by": "Cancelled by %{name} on %{at} · %{reason}",
            "created_at_label": "Entered",
            "drafts_empty": "No purchases are waiting for goods.",
            "history_capped": "Showing the %{shown} most recent of %{total}.",
            "history_empty": "No purchase has been received or cancelled yet.",
            "line_add": "Add supply",
            "line_pack_hint": "We work out the quantity and the cost per %{unit}. The package is not stored: stock only understands the supply's own unit.",
            "line_pack_mode": "I bought it by the package",
            "line_pack_price_label": "Package price",
            "line_packs_label": "Packages",
            "line_quantity_label": "Quantity",
            "line_remove": "Remove supply",
            "line_supply_label": "Supply",
            "line_supply_placeholder": "Pick a supply",
            "line_total_label": "Total",
            "line_unit_cost_label": "Cost per %{unit}",
            "line_unit_cost_short": "Unit cost",
            "line_unit_unknown": "unit",
            "line_units_per_pack_label": "Contents per package (%{unit})",
            "lines_title": "Supplies on this purchase",
            "purchase_cancel": "Cancel purchase",
            "purchase_create": "Save purchase",
            "purchase_draft_hint": "It is saved as a draft. Stock does not move until you receive it.",
            "purchase_invoice_hint": "Optional. It is recorded on every stock movement this purchase produces.",
            "purchase_invoice_label": "Invoice or delivery note",
            "purchase_invoice_placeholder": "A-1234",
            "purchase_new": "New purchase",
            "purchase_receive": "Receive",
            "purchase_supplier_label": "Supplier",
            "purchase_supplier_placeholder": "Pick who you bought from",
            "purchase_total_label": "Purchase total",
            "purchases_empty_hint": "Enter what you ordered from your supplier. When the goods arrive you receive it and stock moves on its own.",
            "purchases_empty_title": "No purchases recorded yet",
            "receive_confirm": "Receive purchase",
            "receive_description": "Receiving adds everything to stock and updates each supply's average cost. This cannot be undone.",
            "receive_submitting": "Receiving…",
            "receive_title": "Did the goods arrive?",
            "received_at_label": "Received",
            "received_by": "Received by %{name} on %{at}",
            "received_note": "This purchase already moved stock and the average cost, so it cannot be cancelled. If something went back to the supplier, record it as a stock movement.",
            "row_invoice": "Invoice %{invoice}",
            "row_lines": "%{count} supplies",
            "row_lines_label": "Supplies",
            "row_no_invoice": "No invoice",
            "section_drafts": "Waiting for delivery",
            "section_history": "History",
            "supplier_active": "Active",
            "supplier_contact_label": "Contact",
            "supplier_contact_placeholder": "Who you deal with",
            "supplier_create": "Create supplier",
            "supplier_delete": "Delete",
            "supplier_delete_confirm": "Delete",
            "supplier_delete_description": "Only a supplier that never delivered anything can be deleted.",
            "supplier_delete_title": "Delete supplier",
            "supplier_form_description": "The name is enough. Contact and phone can be added later.",
            "supplier_has_purchases": "It has %{count} purchase orders, so it can no longer be deleted. Deactivate it so it stops appearing when a purchase is entered.",
            "supplier_inactive": "Inactive",
            "supplier_name_label": "Name",
            "supplier_name_placeholder": "Abarrotes del Centro",
            "supplier_new": "New supplier",
            "supplier_new_title": "New supplier",
            "supplier_phone_label": "Phone",
            "supplier_phone_placeholder": "55 1234 5678",
            "supplier_updated": "Supplier updated.",
            "suppliers_empty_hint": "A supplier is who delivers to you. You will need one to record your first purchase.",
            "suppliers_empty_title": "No suppliers yet",
            "unknown_actor": "Not recorded"
          },
          "receipt_share": {
            "downloaded": "Receipt downloaded.",
            "failed": "The receipt could not be generated. Try again.",
            "share": "Share receipt",
            "sharing": "Generating…",
            "text": "Your receipt for bill #%{id}.",
            "title": "Receipt"
          },
          "refunds": {
            "amount_label": "Amount to return",
            "blocked_fully_refunded": "This payment has already been refunded in full.",
            "blocked_generic": "This payment cannot be refunded.",
            "blocked_not_settled": "This payment has not settled yet.",
            "cancel": "Cancel",
            "confirm": "Confirm refund",
            "description": "Pick the reason and confirm. The refund is recorded under your name.",
            "drawer_no_shift": "Open the register before returning cash: the money comes out of today's drawer and has to be recorded in the shift.",
            "drawer_notice": "You are handing back %{amount} in cash from today's drawer. Count it before confirming: the shift's cash count already deducts it.",
            "issued_failed": "Failed",
            "issued_pending": "In progress",
            "issued_succeeded": "Returned",
            "issued_title": "Refunds on this payment",
            "open": "Refund",
            "provider_notice": "The money goes back to the diner's card. Stripe processes the reversal and it can take several days to show up on their statement.",
            "reason_hint": "The reason goes into this location's log and is what refunds get counted by later.",
            "reason_label": "Refund reason",
            "reason_placeholder": "Pick a reason",
            "submitting": "Refunding…",
            "title": "Refund payment",
            "unknown_actor": "Not recorded"
          },
          "table_detail_workspace": {
            "account": "Bill",
            "add_order": "Add to order",
            "add_something_else": "Add something else",
            "adjust_search_select_other_category": "Adjust your search or select another category.",
            "all": "All",
            "amount_outstanding": "Outstanding",
            "amount_paid": "Paid",
            "amount_to_charge": "Amount to charge",
            "bill": "On bill",
            "bill_views": "Bill views",
            "cancel": "Cancel",
            "cancel_attempt": "Return items",
            "cancel_split": "Cancel split",
            "category": "Uncategorized",
            "charge": "Charge ·",
            "charge_2": "Charge",
            "charge_cash": "Charge cash",
            "charge_terminal": "Charge terminal",
            "choose_item_menu_start": "Choose a product from the menu to start building the bill.",
            "closed_bills_placeholder": "Closed bills will appear here.",
            "confirm_payment": "Confirm payment",
            "decrease_quantity": "Decrease quantity",
            "digital_payment_auto_confirmed": "This digital charge is confirmed automatically via Stripe.",
            "diners": "Diners",
            "dining_room": "Dining room",
            "disabled_table_add_items": "The table is disabled. Reactivate it before adding new products.",
            "disabled_table_open_bill": "The table is disabled. Reactivate it before opening a bill.",
            "dish_count_one": "%{count} dish",
            "dish_count_other": "%{count} dishes",
            "expire_checkout": "Expire session",
            "extra_open_bills": "This table has more than one open bill",
            "extra_open_bills_hint": "Charge or close the bills below so the table can be released.",
            "extras": "Extras",
            "grid": "Grid",
            "history": "History",
            "history_2": "No history",
            "increase_quantity": "Increase quantity",
            "invite": "Invite",
            "invite_link": "Invite link",
            "item": "product",
            "k": "⌘K",
            "list": "List",
            "mark_failure": "Mark failure",
            "menu": "Menu",
            "menu_categories": "Menu categories",
            "no_active_bill": "No active bill yet",
            "no_linked_diners": "No diners linked yet. Use %{invite} to share this table's QR code.",
            "no_linked_diners_static": "No diners linked yet.",
            "no_payments_in_flight": "Nobody is paying right now.",
            "no_settled_payments": "Nothing collected yet.",
            "notes": "Notes",
            "notes_placeholder": "No onion, sauce on the side…",
            "open": "Open",
            "open_without_reservation": "Open without booking",
            "orders": "Orders",
            "payment_progress": "Payment in progress",
            "payments_in_flight": "In flight",
            "payments_settled": "Collected",
            "quantity": "Quantity",
            "ready": "Ready",
            "reopen": "Reopen",
            "reopening": "Reopening…",
            "reservation_arriving": "Arriving now",
            "reservation_booked": "Booked",
            "reservation_conflict_warning": "This table is held for %{time}. If you open it without the booking, %{guest} arrives to an occupied table.",
            "reservation_party": {
              "one": "%{count} guest",
              "other": "%{count} guests"
            },
            "reservation_seat": "Seat",
            "results": "No results",
            "search_dish_drink_ingredient": "Search dish, drink, ingredient…",
            "seats": "Seats",
            "select_item_menu": "Select a product from the menu.",
            "select_line_to_charge": "Select %{name} to charge",
            "selected_lines": {
              "one": "1 item selected",
              "other": "%{count} items selected"
            },
            "share_of_split": "Share of the split",
            "soldout": "Sold out",
            "someone_pays": "%{name} is paying",
            "split_outstanding": "Left to collect",
            "split_progress": "Divided between %{count}",
            "start_bill": "Start the bill",
            "status_table": "Table status",
            "subtotal": "Subtotal",
            "tables": "Tables",
            "tap_dish_menu_add": "Tap a dish from the menu to add it to the bill.",
            "text": "by",
            "total": "Total",
            "unavailable": "Unavailable",
            "unoccupied_actions_note": "%{open} occupies the table and opens its first bill. %{invite} only shares the invitation: the bill is born when the diner arrives.",
            "unoccupied_disabled_hint": "This table cannot take orders. Open Table status above and use Release to make it available again.",
            "unoccupied_disabled_pending_hint": "This table cannot take orders and still has a bill to settle. Charge or cancel it, then release the table.",
            "unoccupied_disabled_title": "Table disabled",
            "unoccupied_free_hint": "Open the table to start taking the order. The menu and the bill show up as soon as it is occupied.",
            "unoccupied_free_title": "Table free",
            "unoccupied_invite": "Open with QR",
            "unoccupied_reserved_hint": "Open it when the diners arrive to start taking the order.",
            "unoccupied_reserved_title": "Table reserved",
            "waiting_for": "%{minutes} min ago",
            "workspace_sections": "Table sections",
            "zone": "Zone"
          },
          "tables_overview": {
            "acknowledge_waiter_call": "Answer",
            "actions_quick": "Quick actions",
            "adjust_filters_search_view": "Adjust the filters or search to see more tables.",
            "all": "All",
            "attention": "Attention (",
            "attention_count": {
              "one": "%{count} needs attention",
              "other": "%{count} need attention"
            },
            "awaiting_release": "Ready to clear",
            "bill": "bill",
            "bills": "Bills",
            "bills_pending": "Pending bills",
            "bills_pending_count": {
              "one": "%{count} pending bill",
              "other": "%{count} pending bills"
            },
            "capacity": "Capacity",
            "charge": "To charge",
            "close": "Close",
            "diners_count": {
              "one": "%{count} diner",
              "other": "%{count} diners"
            },
            "dining_room": "Dining room",
            "dish_ready": "Dish ready",
            "free": "Available",
            "free_2": "Available",
            "go_to_table": "Go to table",
            "grid": "Grid",
            "item": "product",
            "items_ticket": "Products on ticket",
            "kitchen": "Kitchen",
            "last_event": "Last event",
            "list": "List",
            "live": "Live",
            "need_attention_now": "Need attention now",
            "no_diners": "No diners",
            "no_matches": "No matches",
            "no_matches_hint": "Adjust the filters or search to see more tables.",
            "no_recent_updates": "No recent updates.",
            "no_tables": "No tables configured",
            "no_tables_manager_hint": "Configure tables to start running the dining room.",
            "no_tables_staff_hint": "Ask a manager to configure the dining-room tables.",
            "occupancy": "%{percent}% occupied",
            "occupied": "Occupied",
            "occupied_2": "Occupied",
            "open": "open",
            "open_bills_count": {
              "one": "%{count} open",
              "other": "%{count} open"
            },
            "open_table": "Open table",
            "payment": "Payment",
            "people": "People",
            "people_of": "%{count} of %{total}",
            "ready": "Ready",
            "ready_occupy": "Ready to occupy",
            "ready_serve": "Ready to serve",
            "ready_serve_2": "Ready to serve",
            "recent_updates": "Recent updates",
            "require_attention": "Require attention",
            "requires_attention": "Needs attention",
            "sales_pending": "Pending sales",
            "search_table_status_event": "Search table, status, or event…",
            "seats": "seats",
            "seats_2": "seats",
            "seats_count": {
              "one": "%{count} seat",
              "other": "%{count} seats"
            },
            "serve": "Serve",
            "status": "Status",
            "status_disabled": "Disabled",
            "status_reserved": "Reserved",
            "subtotal": "Subtotal",
            "summary": "Summary",
            "table": "Table",
            "table_2": "Table ·",
            "table_3": "Table with",
            "tables": "Tables",
            "taking_order": "Taking order",
            "ticket_kitchen": "Ticket in kitchen",
            "total": "Total",
            "view_mode": "View mode",
            "view_qr": "View QR"
          }
        },
        "user": {
          "cart_screen": {
            "add": "Add",
            "bill": "Bill",
            "bill_empty_back_menu": "Your bill is empty. Go back to the menu to add dishes.",
            "consumed_total": "Consumed total",
            "item": "product",
            "subtract": "Subtract",
            "tip": "Tip",
            "total_table": "Table total"
          },
          "category_chips": {
            "all": "All"
          },
          "coupon_field": {
            "apply": "Apply",
            "applying": "Checking…",
            "empty": "Type your code.",
            "generic": "That code cannot be used.",
            "label": "Have a code?",
            "network_error": "We could not check that code. Try again.",
            "placeholder": "CODE",
            "rate_limited": "Too many attempts. Wait a moment before trying another code.",
            "remove": "Remove the code"
          },
          "create_order": {
            "add_order": "Add Order",
            "cancel": "Cancel",
            "create_new_order_table": "Create a new order for your table.",
            "order": "Order"
          },
          "create_order_form": {
            "add_order": "Add Order",
            "adding_order": "Adding order...",
            "example_onion_well_cooked_etc": "E.g.: No onion, well done, etc.",
            "information_additional_order_optional": "Additional information for the order (optional)",
            "notes": "Notes",
            "quantity": "Quantity",
            "quantity_products_ask": "The quantity of products to order",
            "type_service": "Service Type",
            "type_service_order": "The service type for the order"
          },
          "directory": {
            "closed": "Closed",
            "distance_km": "%{value} km",
            "empty": "Search for a restaurant to order pickup.",
            "locating": "Locating you…",
            "location_denied": "We couldn't get your location.",
            "near_me": "Near me",
            "no_results": "No restaurants found for \"%{query}\".",
            "open": "Open",
            "pickup_unavailable": "Not taking pickup orders",
            "search_placeholder": "Search restaurants",
            "sorted_by_distance": "Sorted by distance",
            "title": "Restaurants"
          },
          "dish_detail": {
            "15_min": "15 min",
            "add": "Add",
            "back": "Back",
            "cilantro_allergies_etc": "No cilantro, allergies, etc.",
            "customize_order": "Customize your order",
            "dish_payer": "Who pays for this dish",
            "eat_in": "Eat here",
            "favorite": "Favorite",
            "notes_kitchen": "Notes for the kitchen",
            "only": "Just for me",
            "optional": "Optional",
            "recipe_house": "House recipe",
            "select_want_add": "Select what you want to add",
            "service_type_question": "How would you like it?",
            "subtract": "Subtract",
            "table": "For the table",
            "take_out": "To go",
            "who": "For whom?"
          },
          "dish_list_item": {
            "add": "Add %{name}"
          },
          "dish_price": {
            "original": "Regular price:",
            "promoted": "Promotional price:"
          },
          "farewell_screen": {
            "bill_closed_at": "We closed your bill at %{name}.",
            "bill_closed_generic": "Your bill is now closed.",
            "go_home": "Go home",
            "table_closed": "Table %{name} is free again. Come back soon.",
            "thanks_for_visit": "Thanks for visiting!",
            "view_bill": "View my bill"
          },
          "featured_card": {
            "15_min": "15 min",
            "favorite": "Favorite",
            "recommended": "Recommended"
          },
          "home_screen": {
            "active_now": "Active now",
            "categories": "Categories",
            "clear_search": "Clear search",
            "continue_ordering": "Continue your order",
            "dishes": "dishes",
            "featured_house": "House favorites",
            "greeting": "Hi, %{name}",
            "hello": "Hello",
            "home": "Delivery",
            "more": "More",
            "no_products_in_category": "No products available in this category.",
            "no_results": "No dishes found for \"%{query}\".",
            "no_visits": "No visits yet. Scan your table's QR code to get started.",
            "notifications": "Notifications",
            "order_pickup": "Order pickup",
            "pickup": "Pickup",
            "pickup_context": "For pickup",
            "results": "Results",
            "scan_qr": "Scan QR",
            "search_dish_ingredient": "Search for a dish or ingredient…",
            "search_restaurants": "Search restaurants",
            "subtitle": "What are you craving today?",
            "table": "At table",
            "text": "You're at",
            "view_menu": "View menu",
            "view_receipt": "View receipt",
            "your_visits": "Your visits"
          },
          "order_line": {
            "discount": "Discount"
          },
          "pay_sheet": {
            "already_paid": "Paid",
            "back": "Back",
            "cancel_split": "Cancel the split",
            "cash_subtitle": "Staff confirms the cash payment when received.",
            "choose_items": "Choose the items",
            "choose_method_payment": "Choose your payment method.",
            "choose_scope_tip_method": "Choose what you cover, the tip and how you pay.",
            "confirm_divide": "Divide between %{count}",
            "continue_to_checkout": "Continue to checkout",
            "custom_tip_field_label": "Tip amount",
            "custom_tip_label": "Other amount",
            "custom_tip_short": "Other",
            "digital_checkout_subtitle": "Redirects to secure Stripe Checkout.",
            "divide_locked": "The table is already dividing. Items cannot be paid separately.",
            "method": "Method",
            "mode_divide": "Divide the bill",
            "mode_divide_hint": "The total is split into equal shares.",
            "mode_items": "Each pays their own",
            "mode_items_hint": "You pick the items you cover.",
            "network_error": "We could not start the charge. Try again in a few seconds.",
            "no_payment_methods": "This restaurant has not enabled diner payment methods yet.",
            "nothing_mine": "No products of yours",
            "nothing_selected": "Choose at least one item.",
            "offline_payment_pending": "The charge is pending staff confirmation.",
            "only_mine": "Only mine",
            "opening_split": "Opening…",
            "pay": "Pay",
            "payers_left": "%{count} left to pay",
            "people_paying": "Between how many?",
            "processing": "Processing…",
            "request_staff_charge": "Request charge",
            "reserved_by_other": "In another payment",
            "select_all": "Whole bill",
            "select_mine": "Only mine",
            "settle_hint": "The table decides this once.",
            "settle_question": "How are you paying?",
            "share_below_minimum": "At that number the shares are too small to pay by card in the app.",
            "subtotal": "Subtotal",
            "terminal_subtitle": "Staff charges with the physical terminal.",
            "tip": "Tip",
            "total_payable": "Payable total",
            "what_you_pay": "What are you paying?",
            "whole_bill": "Whole bill",
            "your_share": "Your share"
          },
          "pickup_cart": {
            "added": "Added to your order",
            "back_to_menu": "See the menu",
            "empty": "You have not added anything yet.",
            "network_error": "We could not connect. Try again.",
            "opening_payment": "Opening payment...",
            "pay": "Pay",
            "refusal_changed": "Something changed on the menu: %{items}. Check your order before paying.",
            "refusal_changed_generic": "Something changed on the menu. Check your order before paying.",
            "refusal_empty": "Your order is empty.",
            "refusal_location_closed": "This restaurant is closed right now.",
            "refusal_location_unavailable": "This restaurant is no longer taking pickup orders.",
            "refusal_payment_unavailable": "We could not open the payment. Try again later.",
            "refusal_rate_limited": "Too many attempts. Wait a moment before paying again.",
            "refusal_registration_required": "You need a registered account to pay.",
            "register_to_pay": "Create an account to pay",
            "remove": "Remove from order",
            "service_fee": "Service fee (%{percentage}%%)",
            "subtotal": "Subtotal",
            "title": "Your order",
            "total": "Total"
          },
          "pickup_closed": {
            "cannot_order": "Ordering is closed",
            "opens_at": "Opens %{date}",
            "title": "Closed right now"
          },
          "receipt_screen": {
            "net_total": "Total after refunds",
            "paid_on": "Paid on %{date}",
            "payment_method": "Payment method",
            "refunds": "Refunds",
            "request_invoice": "Request an invoice",
            "service_fee": "Service fee",
            "subtotal": "Subtotal",
            "tax_line": "%{name} (%{rate}%)",
            "taxes_included": "Taxes included in what you paid",
            "title": "Receipt",
            "total": "Total"
          },
          "screen_header": {
            "back": "Back",
            "more_actions": "More actions"
          },
          "self_invoice_form": {
            "constancia_hint": "All of these are on your constancia de situación fiscal. If they do not match, the SAT rejects the invoice.",
            "legal_name": "Legal name",
            "legal_name_hint": "Exactly as it appears on your constancia de situación fiscal, without the abbreviated company type.",
            "paid_on": "Paid on %{date}",
            "postal_code": "Tax postal code",
            "rfc": "RFC",
            "submit": "Generate my invoice",
            "tax_regime": "Tax regime",
            "tax_regime_placeholder": "Choose your regime",
            "total": "Bill total",
            "usage": "Invoice usage",
            "usage_placeholder": "Choose the usage"
          },
          "tab_bar": {
            "bill": "Bill",
            "home": "Home",
            "menu": "Menu",
            "orders": "Orders",
            "receipts": "Receipts"
          },
          "tracking_screen": {
            "approx": "approx.",
            "ask_water_something_more": "Ask for water, something else",
            "back": "Back",
            "back_menu": "Back to menu",
            "call_waiter": "Call waiter",
            "changes_allergies": "Changes or allergies",
            "minutes": "minutes",
            "notes_kitchen": "Notes for the kitchen",
            "order_mny": "Order #MNY-"
          }
        }
      },
      "pages": {
        "admin": {
          "dashboards": {
            "index": {
              "actions": "Actions",
              "amount": "Amount",
              "cancel": "Cancel",
              "days_owed": "Days owed",
              "forgive": "Forgive",
              "forgive_description": "The $%{amount} owed by %{name} is written off and can never be collected. The reason is all that will be left to explain it.",
              "forgive_title": "Forgive this debt?",
              "last_failure": "Last decline",
              "location": "Restaurant",
              "no_attempts": "No attempts",
              "period": "Period",
              "reason": "Reason",
              "reason_placeholder": "What happened and what was agreed.",
              "search": "Search by restaurant",
              "showing": "Showing %{count} of %{total} invoices",
              "status": "Status",
              "suspend": "Suspend",
              "suspend_description": "%{name} stops operating until they are current. They can pay the $%{amount} at any time and it reactivates on its own.",
              "suspend_title": "Suspend operation?",
              "title": "Commission owed"
            },
            "show": {
              "location_col": "Location",
              "new_locations": "New locations",
              "new_users": "New users",
              "no_sales": "No sales this period",
              "period_day": "Daily",
              "period_month": "Monthly",
              "period_year": "Yearly",
              "sales_col": "Sales",
              "service_fee_col": "Service fee",
              "service_fees": "Service fees",
              "subtitle": "Business overview",
              "top_locations": "Top locations",
              "top_locations_subtitle": "Highest sales and service fees",
              "total_sales": "Total sales",
              "vs_previous": "vs. previous period"
            }
          },
          "events": {
            "index": {
              "events": "Events"
            }
          },
          "jobs": {
            "index": {
              "action": "Action",
              "active": "Active",
              "arg1_key_value": "{} or [\"arg1\", {\"key\": \"value\"}]",
              "arguments_json": "JSON Arguments",
              "available": "Available",
              "blocked": "Blocked",
              "blocked_2": "Blocked",
              "blocked_3": "· Blocked:",
              "cancel": "Cancel",
              "created": "Created",
              "date": "Date",
              "definitions_active_registered_solid_queue": "Active definitions registered by the Solid Queue scheduler.",
              "enqueue_job": "Enqueue job",
              "enqueue_job_description": "Queueing %{className} in %{queueName}",
              "errors_recent_saved_solid_queue": "Recent errors saved in `solid_queue_failed_executions`.",
              "exception": "Exception",
              "execution": "Running",
              "executions_pending": "Pending executions",
              "failed": "Failed",
              "failed_2": "Failed",
              "failures": "Failures",
              "finished": "Finished",
              "healthy": "Healthy",
              "heartbeat": "No heartbeat",
              "heartbeat_workers_dispatchers": "Worker/dispatcher heartbeat.",
              "host": "Host",
              "job": "Job",
              "job_class": "Job class",
              "jobs": "Jobs",
              "jobs_created_solid_queue": "jobs created in Solid Queue.",
              "jobs_ready_scheduled_blocked_execution": "Jobs ready, scheduled, or blocked for execution.",
              "jobs_recent": "Recent jobs",
              "key": "Key",
              "kind": "Kind",
              "last_heartbeat": "Last heartbeat",
              "last_run": "Last run",
              "latest": "Latest",
              "latest_24h": "In the last 24h:",
              "latest_24h_2": "Last 24h:",
              "latest_failures": "Latest failures",
              "message": "Message",
              "next_run": "Next run",
              "no_available": "Not available",
              "no_could_read_tables_solid": "Could not read Solid Queue tables",
              "no_executable_jobs": "No executable jobs found.",
              "no_failed_executions": "No failed executions.",
              "no_pending_executions": "No pending executions.",
              "no_queue_data": "No queue data.",
              "no_recent_jobs": "No recent jobs.",
              "no_recurring_tasks": "No recurring tasks.",
              "no_registered_processes": "No registered processes.",
              "operation": "Operation",
              "paused": "Paused",
              "priority": "Priority",
              "process": "Process",
              "processes_queue": "Queue processes",
              "queue": "Queued",
              "queue_2": "Queue",
              "queued": "Queued",
              "queues": "Queues",
              "recurrences": "Recurrences",
              "run": "Run",
              "run_job": "Run job",
              "run_job_manually": "Run job manually",
              "running": "Running",
              "schedule": "Schedule",
              "scheduled": "Scheduled",
              "scheduled_2": "Scheduled",
              "scheduled_3": "Scheduled:",
              "select_job_available_app_jobs": "Select a job available in `app/jobs`, optionally define JSON arguments, and enqueue the run.",
              "signature_perform": "perform signature",
              "some_tables_no_available": "Some tables are not available",
              "status": "Status",
              "status_queue": "Status by queue",
              "table": "Table",
              "table_role_summary": "Summary of each table's role per `db/queue_schema.rb`.",
              "tables_solid_queue": "Solid Queue tables",
              "tasks_recurring": "Recurring tasks",
              "total_jobs": "Total jobs",
              "update": "Update",
              "usage_operational": "Operational usage",
              "use_object_json_keyword_args": "Use a JSON object for keyword args or a JSON array for positional arguments.",
              "view_operational_backlog_execution_pauses": "Operational view of backlog, execution, and pauses.",
              "workers_active": "Active workers:"
            }
          },
          "locations": {
            "edit": {
              "description": "Global metadata, status, fees, and the features this location may use.",
              "detail_address": "Address",
              "detail_created_at": "Created",
              "detail_id": "ID",
              "detail_organization": "Organization",
              "detail_status": "Status",
              "detail_time_zone": "Time zone",
              "detail_updated_at": "Last updated",
              "details_title": "Location information",
              "feature_in_use": "In use by the restaurant",
              "feature_not_in_use": "Switched off by the restaurant",
              "features_description": "Decide which features this location may use. The restaurant chooses which ones it turns on.",
              "features_granted_count": "%{granted} of %{total}",
              "form_title": "Editable information",
              "tab_details": "Details",
              "tab_features": "Features",
              "title": "Edit location"
            },
            "form": {
              "cancel": "Cancel",
              "name": "Name",
              "pickup_diner_fee_percentage": "Pickup fee charged to the diner (%)",
              "pickup_restaurant_fee_percentage": "Pickup fee charged to the restaurant (%)",
              "save": "Save location",
              "status": "Status",
              "time_zone": "Time zone"
            },
            "index": {
              "actions": "Actions",
              "created": "Created",
              "delete": "Delete",
              "delete_description": "This hides the location from admin and preserves its operational history. It does not delete bills, tables, or orders.",
              "delete_title": "Delete location",
              "digital": "Digital",
              "edit": "Edit",
              "locations": "Locations",
              "name": "Name",
              "new_location": "New location",
              "offline": "Offline",
              "pickup_fees": "Pickup fees (diner / restaurant)",
              "search_locations": "Search locations...",
              "showing": "Showing %{count} of %{total} locations",
              "staff": "Staff",
              "status": "Status",
              "tables": "Tables"
            },
            "new": {
              "description": "Create the global location record. Manager assignment and operations remain in staff.",
              "title": "New location"
            }
          },
          "sign_in": {
            "index": {
              "continue_with_google": "Continue with Google",
              "sign_in_with_google_description": "Sign in to the admin panel with your Google account.",
              "welcome_new": "Welcome back"
            }
          },
          "system_status": {
            "index": {
              "booted_at": "Up since",
              "build_title": "Build",
              "databases_title": "Databases",
              "description": "Deployed version and service health.",
              "environment": "Environment",
              "generated_at": "Updated",
              "latency": "Latency",
              "migration": "Migration",
              "rails": "Rails",
              "refresh": "Refresh",
              "revision": "Commit",
              "ruby": "Ruby",
              "status_down": "Down",
              "status_unknown": "Unknown",
              "status_up": "Up",
              "title": "System status"
            }
          },
          "transactions": {
            "index": {
              "actions": "Actions",
              "all": "All",
              "amount": "Amount",
              "created_at": "Date",
              "diner": "Diner",
              "location": "Restaurant",
              "no_provider": "Never reached Stripe",
              "open": "View detail",
              "payment_method": "Method",
              "provider": "Provider",
              "search": "Search by restaurant, diner or id",
              "showing": "Showing %{count} of %{total} payment attempts",
              "status": "Status",
              "title": "Transactions"
            },
            "show": {
              "amount_charged": "Amount charged",
              "application_fee": "Platform fee",
              "attempt": "Attempt",
              "back": "Back",
              "bill": "Bill",
              "bill_split": "Split",
              "charge": "Charge",
              "checkout_expires_at": "Checkout expires",
              "checkout_session": "Checkout session",
              "completed_at": "Resolved",
              "connected_account": "Connected account",
              "context": "Context",
              "created_at": "Created",
              "diner": "Diner",
              "diner_email": "Email",
              "failure_title": "This payment failed",
              "idempotency_key": "Idempotency key",
              "kind": "Kind",
              "kind_orders": "Selected items",
              "kind_pickup": "Pickup order",
              "kind_share": "Share of a split bill",
              "location": "Restaurant",
              "no_orders": "None yet",
              "no_provider": "This attempt never reached Stripe. A cash or terminal payment never does; a digital one that landed here was refused before the session was opened.",
              "payment_intent": "Payment intent",
              "payment_method": "Payment method",
              "provider": "Stripe",
              "provider_completed_at": "Resolved at Stripe",
              "provider_name": "Provider",
              "provider_raw_status": "Status per Stripe",
              "provider_status": "Status",
              "refund": "Refund",
              "selected_orders": "Charged orders",
              "snapshot": "Snapshot",
              "status": "Status",
              "subtotal": "Subtotal",
              "tip": "Tip",
              "title": "Payment attempt",
              "total": "Total"
            }
          },
          "users": {
            "index": {
              "admin": "Admin",
              "create_admin": "Create admin",
              "revoke": "Revoke access",
              "revoke_confirm": "Revoke this user's admin access?",
              "search_users": "Search users...",
              "users": "Users"
            },
            "new": {
              "cancel": "Cancel",
              "create": "Grant access",
              "description": "Enter the person's Google email. They will be able to sign in with that email via Google.",
              "email": "Email",
              "email_placeholder": "person@example.com",
              "title": "New admin"
            }
          }
        },
        "staff": {
          "location": {
            "bills": {
              "index": {
                "bill": "Bill",
                "bills": "Bills",
                "search_bill_status": "Search by bill or status..."
              }
            },
            "dashboards": {
              "show": {
                "action_acknowledge": "Acknowledged",
                "action_open_table": "Open table",
                "action_release": "Release",
                "attention_empty_hint": "The floor is caught up. When a table rings, a plate goes cold or a charge gets stuck, it shows up here.",
                "attention_empty_title": "Nothing pending",
                "attention_filtered_hint": {
                  "one": "%{count} item is still pending in other groups.",
                  "other": "%{count} items are still pending in other groups."
                },
                "attention_filtered_title": "Nothing in %{group}",
                "attention_subtitle": "What needs a person right now, most urgent first.",
                "attention_title": "Needs attention",
                "collected_today": {
                  "one": "Collected today · %{count} bill",
                  "other": "Collected today · %{count} bills"
                },
                "dining_room": "Dining room",
                "group_all": "All",
                "group_door": "Door",
                "group_payment": "Payment",
                "group_service": "Service",
                "group_tables": "Tables",
                "kitchen": "Kitchen",
                "no_tables": "No tables configured",
                "occupancy": "%{percent}% occupied",
                "oldest_open_bill": "oldest opened %{age}",
                "open_bills": {
                  "one": "%{count} open bill",
                  "other": "%{count} open bills"
                },
                "overview": "Location overview",
                "pipeline_hint": "The age is that of the oldest order in each stage. After %{minutes} minutes in Ready, the table joins the list above.",
                "stage_empty": "no queue",
                "stage_in_progress": "In preparation",
                "stage_oldest": "oldest, %{age}",
                "stage_pending": "Pending",
                "stage_ready": "Ready",
                "status_available": "Available",
                "status_disabled": "Disabled",
                "status_occupied": "Occupied",
                "status_reserved": "Reserved",
                "tables_count": {
                  "one": "%{count} table",
                  "other": "%{count} tables"
                },
                "tips_today": "%{amount} in tips",
                "title": "Activity",
                "to_collect": "To collect",
                "todays_till": "Today's till",
                "view_bills": "View bills",
                "view_orders": "View orders",
                "view_tables": "View tables"
              }
            },
            "deliveries": {
              "index": {
                "assign_placeholder": "Assign to",
                "deliver": "Delivered",
                "empty": "No deliveries in progress.",
                "fail": "Could not deliver",
                "fail_cancel": "Back",
                "fail_confirm": "Mark as failed",
                "fail_description": "Pick the reason. It stays in the history and the courier becomes available again.",
                "fail_reason_label": "Reason",
                "fail_reason_placeholder": "Pick a reason",
                "fail_submitting": "Saving...",
                "fail_title": "What happened to the delivery?",
                "no_courier": "Nobody on shift",
                "page_description": "What is out on the road right now.",
                "page_title": "Deliveries",
                "pick_up": "Picked up",
                "row_meta": "Fee %{fee}",
                "row_meta_courier": "%{courier} · fee %{fee}",
                "title": "Out for delivery"
              }
            },
            "kds": {
              "show": {
                "advance_to_in_progress": "Start",
                "advance_to_ready": "Mark ready",
                "degraded": "Live connection lost",
                "empty": "Nothing pending at this station.",
                "late": "Late",
                "live": "Live",
                "minutes_waiting": "%{count} min waiting",
                "no_table": "No table",
                "ready": "Ready",
                "refreshed": "Refreshed",
                "station": "Station",
                "title": "Station",
                "undo": "Undo",
                "warning": "Slow"
              }
            },
            "manage": {
              "billing": {
                "settings": {
                  "activation_hint": "Complete these steps to start charging online.",
                  "activation_step_connected": "Stripe connected",
                  "activation_step_methods": "Payment methods chosen",
                  "activation_step_profile": "Business profile complete",
                  "activation_step_ready": "Ready to charge online",
                  "activation_title": "Activate payments",
                  "address_stripe": "Address for Stripe",
                  "applies_payments_cash_terminal": "Applies to cash and physical terminal payments.",
                  "back_to_summary": "Back to summary",
                  "bill_connected": "Account connected",
                  "business_description": "Business description",
                  "cancel": "Cancel",
                  "city": "City",
                  "code_postal": "Postal code",
                  "company": "Company",
                  "configuration_visible_payment_daily_location": "Settings visible for the location's daily billing.",
                  "confirmed_visible_methods": "I confirmed diner-visible methods before go-live",
                  "connect_stripe": "Connect Stripe",
                  "continue_onboarding": "Continue onboarding",
                  "country": "Country",
                  "default_recommended_connect_zero_freezes": "Recommended default for Connect: 1.00%. Held per payment attempt.",
                  "email": "Email",
                  "email_support": "Support email",
                  "extra": "Add-on",
                  "field_required_continue_stripe": "Field required to continue with Stripe.",
                  "information_use_prefillear_stripe_connect": "This information is used to prefill Stripe Connect and minimize manual entry.",
                  "last_name": "Last name",
                  "legal_name": "Legal name / company name",
                  "location_suspended_missing_payment": "The location is suspended because the account is unpaid. Settle it to unblock the location.",
                  "max_22_characters_see": "Maximum 22 characters. This is what the customer will see on their statement.",
                  "method_cash_hint": "The customer pays cash directly to your staff.",
                  "method_digital_hint": "The customer pays from the app with their card.",
                  "method_terminal_hint": "You charge with your physical card terminal on site.",
                  "methods_payment_enabled": "Enabled payment methods",
                  "name": "Name",
                  "name_business": "Business name",
                  "person_physical": "Individual",
                  "phone": "Phone",
                  "phone_support": "Support phone",
                  "profile_payment": "Billing profile",
                  "refresh_status": "Refresh status",
                  "representative": "Representative",
                  "requires_stripe_connection": "Connect Stripe to enable digital payments.",
                  "restaurant_casual_mexican_consumption_table": "Casual Mexican restaurant with table service.",
                  "restriction": "Restriction:",
                  "save_before_stripe": "Save this profile before opening Stripe to avoid entering data twice.",
                  "save_continue_stripe": "Save and continue with Stripe",
                  "save_profile_payment_once_time": "Save the billing profile once and let Stripe ask only for what's missing.",
                  "save_settings": "Save settings",
                  "settings_billing": "Billing settings",
                  "site_web": "Website",
                  "some_data_additional_completed_directly": "Some additional data is filled out directly in Stripe during onboarding.",
                  "statement_descriptor": "Statement descriptor",
                  "status": "Status",
                  "street_number": "Street and number",
                  "subscription": {
                    "add_seat_cta": "Pay for this restaurant",
                    "branches": "Per-branch breakdown",
                    "current_cta": "Start subscription",
                    "current_description": "Your subscription is up to date.",
                    "delinquent_cta": "Restore subscription",
                    "delinquent_description": "We could not charge your subscription and your restaurants stopped taking diners. Update your payment method to bring them back.",
                    "last_charge": "Last charge",
                    "paused_cta": "Start subscription",
                    "paused_description": "Your subscription is paused. Your restaurants keep operating.",
                    "pending_cta": "Start subscription",
                    "pending_description": "We are waiting for your payment to clear. The restaurant opens on its own once it does.",
                    "renews_at": "Renews on",
                    "title": "Menny subscription",
                    "unbilled_cta": "Start subscription",
                    "unbilled_description": "This restaurant cannot open yet. Start the subscription to put it into service."
                  },
                  "support_phone_edit_link": "Edit in operational configuration",
                  "support_phone_managed_operational": "The support phone is set in operational configuration.",
                  "type_business": "Business type",
                  "use_address_structured_text_free": "Use a structured address; free-form operational text isn't enough to properly prefill onboarding.",
                  "yes_company_use_data_prefillear": "If it's a company, we use this data to prefill the representative. If it's an individual, it applies to the owner."
                },
                "show": {
                  "alertas": "· Alerts",
                  "billing": "Billing and invoicing",
                  "cash_terminal_physical": "Cash and physical terminal.",
                  "confirmation_diner_visible": "Diner-visible confirmation",
                  "expires": "Expires",
                  "frozen_attempt_payment": "Held per payment attempt.",
                  "issued": "Issued",
                  "latest_cycles_generated_location": "Latest cycles generated for the location.",
                  "manage_settings": "Manage settings",
                  "methods_enabled": "Enabled methods",
                  "methods_visible": "Visible methods",
                  "no_invoices": "No invoices generated yet.",
                  "pay_invoice": "Pay now",
                  "pay_invoice_hint": "We send you to Stripe so you can pay with whichever card you like.",
                  "payment_in_progress": "Charge in progress",
                  "period": "Period",
                  "reminders": "· Reminders",
                  "settings": "Settings",
                  "signals_quick_operate_open_settings": "Quick signals to operate without opening settings.",
                  "status_financial_payment_location": "Financial and payment status for this location.",
                  "status_payment": "Payment status"
                }
              },
              "business_hours": {
                "show": {
                  "back": "Branch",
                  "description": "Control when this location operates at different times of day.",
                  "disabled": "Disabled",
                  "enabled": "Enabled",
                  "title": "Business hours"
                }
              },
              "categories": {
                "edit": {
                  "back_menu": "Back to menu",
                  "edit_category": "Edit category",
                  "name": "Name",
                  "starters": "Starters",
                  "update_name_category": "Update the category name."
                },
                "new": {
                  "cancel": "Cancel",
                  "create_category": "Create category",
                  "create_category_organize_items": "Create a category to organize your products.",
                  "name": "Name",
                  "new_category": "New category",
                  "starters": "Starters"
                }
              },
              "central_items": {
                "index": {
                  "add": "Add",
                  "empty": "Your organization has no central dishes yet. Add the first one and it appears in every branch that adopts it.",
                  "name_label": "Dish",
                  "page_title": "Central menu",
                  "price_label": "Price",
                  "reach": "Reaches %{following} branches",
                  "reach_with_overrides": "Reaches %{following} · %{overriding} with their own price",
                  "remove": "Remove %{name} from the central menu",
                  "subtitle": "What you write here reaches %{branches} branches.",
                  "title": "Group dishes"
                }
              },
              "channels": {
                "index": {
                  "all_healthy": "Every channel is responding.",
                  "connect": "Connect",
                  "connect_title": "Connect a channel",
                  "credential_key_hint": "This is the reference to the credential, not the credential. The token is never stored here.",
                  "credential_key_label": "Credential reference",
                  "disconnect": "Disconnect %{platform}",
                  "empty": "You have not connected any channel yet.",
                  "healthy": "Up to date",
                  "last_failure": "%{reason} · %{at}",
                  "last_sync": "Last signal %{at}",
                  "never_synced": "Never reported. We do not know yet whether it works.",
                  "not_in_reports": "Orders from these channels do not appear in the product mix and do not move stock, because they materialize no order lines.",
                  "orders_title": "Channel orders",
                  "page_description": "Uber Eats, Rappi and DiDi Food.",
                  "page_title": "Channels",
                  "platform_label": "Platform",
                  "store_id_label": "Store ID",
                  "title": "Channel health",
                  "unhealthy": "Has problems",
                  "unhealthy_count": "%{count} channel(s) with problems",
                  "unknown_time": "no date",
                  "unresolved": "%{count} unresolved order(s)"
                }
              },
              "couriers": {
                "index": {
                  "add": "Add",
                  "available_count": "%{count} available to take a delivery",
                  "couriers_title": "Couriers",
                  "empty": "You have not added any courier yet.",
                  "end_shift": "End shift",
                  "name_label": "Name",
                  "page_description": "Your own delivery team and the zones it covers.",
                  "page_title": "Couriers",
                  "phone_label": "Phone",
                  "remove": "Remove %{name}",
                  "start_shift": "Start shift",
                  "zone_meta": "%{radius} m · fee %{fee} · minimum %{minimum}",
                  "zones_empty": "No zones defined yet. Without a zone there is no calculated delivery fee.",
                  "zones_subtitle": "How far you go and what you charge",
                  "zones_title": "Delivery zones"
                }
              },
              "customers": {
                "index": {
                  "add": "Add",
                  "balance": "%{points} points",
                  "earn": "Earn",
                  "empty": "You have not registered any customer yet.",
                  "ledger_empty": "No activity yet.",
                  "ledger_subtitle": "The most recent earning and redeeming",
                  "ledger_title": "Points activity",
                  "linked": "has an account",
                  "name_label": "Name",
                  "outstanding": "%{points} points outstanding",
                  "page_description": "This restaurant's customers and the points they hold here.",
                  "page_title": "Customers",
                  "phone_label": "Phone",
                  "points_label": "Points for %{name}",
                  "points_placeholder": "Points",
                  "redeem": "Redeem",
                  "title": "Customers"
                }
              },
              "dashboard": {
                "show": {
                  "created": "Created:",
                  "customer": "Customer",
                  "dashboard_management": "Management dashboard",
                  "distribution_current_tables": "Current table distribution.",
                  "latest_orders_active_registered": "Latest active orders recorded.",
                  "load_station": "Load by station",
                  "no_recent_active_orders": "No recent active orders.",
                  "orders_active_assigned_station": "Active orders assigned by station.",
                  "orders_recent": "Recent orders",
                  "orders_status": "Orders by status",
                  "status_current_flow_operational": "Current status of the operational flow.",
                  "tables_status": "Tables by status",
                  "visibility_quick_operation_restaurant": "Quick visibility into restaurant operations."
                }
              },
              "events": {
                "index": {
                  "events_location": "Location events",
                  "header_date": "Date",
                  "header_event": "Event",
                  "header_id": "ID",
                  "showing_events": "Showing %{count} of %{total} events (most recent first)"
                }
              },
              "items": {
                "edit": {
                  "cancel": "Cancel",
                  "category": "Category",
                  "category_2": "No category",
                  "currency": "Currency",
                  "description": "Description",
                  "edit_item": "Edit product",
                  "item_parent": "No parent product",
                  "item_parent_modifier": "Parent product (modifier)",
                  "name": "Name",
                  "photo_item": "Product photo",
                  "price": "Price",
                  "save_changes": "Save changes",
                  "station_primary": "Primary station",
                  "status": "Status",
                  "taco_pastor": "Al pastor taco",
                  "tortilla_corn_meat_marinada_pineapple": "Corn tortilla with marinated meat and pineapple",
                  "update_information_item": "Update the product information.",
                  "view_preview_item": "Product preview"
                },
                "new": {
                  "cancel": "Cancel",
                  "category": "Category",
                  "category_2": "No category",
                  "create_item": "Create product",
                  "create_item_menu": "Create a product for the current location's menu.",
                  "currency": "Currency",
                  "description": "Description",
                  "emoji": "Emoji",
                  "emoji_hint": "Shown on the diner menu when the product has no photo.",
                  "extra_groups": "Extra groups",
                  "name": "Name",
                  "new_item": "New product",
                  "photo_item": "Product photo",
                  "price": "Price",
                  "station_primary": "Primary station",
                  "status": "Status",
                  "taco_pastor": "Taco al pastor",
                  "tortilla_corn_meat_marinada_pineapple": "Corn tortilla with marinated meat and pineapple",
                  "view_preview_item": "Product preview"
                },
                "show": {
                  "action_delete_item_menu_can": "This action will delete the menu product. You can continue or cancel.",
                  "back_menu": "Back to menu",
                  "cancel": "Cancel",
                  "category": "Category",
                  "delete": "Delete",
                  "delete_item": "Delete product",
                  "description": "Description",
                  "detail_item_menu": "Menu product detail.",
                  "edit": "Edit",
                  "image": "No image",
                  "item_parent": "Parent product",
                  "price": "Price",
                  "station": "Station",
                  "status": "Status"
                }
              },
              "location": {
                "sections": {
                  "address": "Address",
                  "address_line1": "Street address",
                  "address_line1_placeholder": "123 Alvaro Obregon Ave.",
                  "address_line2": "Apt or landmark",
                  "address_line2_placeholder": "Floor 2, unit B",
                  "all_ready_launch": "All set to launch.",
                  "avenue_juarez_cdmx": "123 Juárez Ave., Mexico City",
                  "billing_separate_operations": "Billing and invoicing are managed separately so operations and finances don't get mixed.",
                  "business_hours": "Business hours",
                  "business_hours_description": "Structured weekly schedule for this location.",
                  "business_hours_disabled": "Disabled",
                  "business_hours_enabled": "Enabled",
                  "checklist_launch": "Launch checklist",
                  "city": "City",
                  "city_placeholder": "Mexico City",
                  "configuration_operational": "Operational settings",
                  "configure_business_hours": "Set up",
                  "coordinates": "Coordinates",
                  "coordinates_hint": "Exact location for proximity search. Optional.",
                  "country": "Country",
                  "country_placeholder": "MX",
                  "define_data_operational_minimum_launch": "Set the minimum operational data needed to go live.",
                  "description": "Description",
                  "description_hint": "Shown on your menu's public page and helps people find you on Google. Optional.",
                  "description_placeholder": "Tell diners what makes your restaurant special.",
                  "directory_profile_description": "This information shows up when diners search for your restaurant to order pickup.",
                  "directory_profile_title": "Directory profile",
                  "feature_blocked_missing_slug": "Choose your menu address below to start receiving pickup orders.",
                  "features_description": "Turn on and off what your restaurant offers diners.",
                  "features_empty": "No features are available for your restaurant yet.",
                  "features_title": "Features",
                  "go_billing": "Go to billing",
                  "last_launch": "Last launch:",
                  "latitude": "Latitude",
                  "launch_location": "Launch location",
                  "logo": "Logo",
                  "logo_hint": "Shown in the public directory. PNG, JPG or WEBP.",
                  "logo_updated": "Logo updated.",
                  "longitude": "Longitude",
                  "postal_code": "Postal code",
                  "postal_code_placeholder": "06700",
                  "preview_label": "How diners see you",
                  "preview_no_description": "No description yet — they will only see the name and the address.",
                  "public_menu_description": "The version of your menu anyone can see on the internet, no sign-in required.",
                  "public_menu_slug_change_confirm": "Change address",
                  "public_menu_slug_change_description": "The old address will keep leading to your menu, so nothing you've already shared breaks. Share the new one from now on.",
                  "public_menu_slug_change_title": "Change your menu's address?",
                  "public_menu_slug_label": "Your menu's address",
                  "public_menu_state_pending": "Pending",
                  "public_menu_state_published": "Published",
                  "public_menu_state_unpublished": "Unpublished",
                  "public_menu_switch_description": "Shows your menu at the address below. Turn it on whenever you want people to see it.",
                  "public_menu_switch_label": "Publish menu",
                  "public_menu_title": "Public menu",
                  "public_menu_url_empty": "Choose an address for your public menu.",
                  "save_configuration": "Save settings",
                  "save_logo": "Save logo",
                  "state": "State",
                  "state_placeholder": "CDMX",
                  "support_phone": "Support phone",
                  "support_phone_hint": "Shown on your menu's public page and the phone your diners will see; we also use it as your Stripe support number.",
                  "support_phone_placeholder": "+52 55 1234 5678",
                  "taxes_description": "The regime you operate under and the rates broken out on your diners' receipts.",
                  "taxes_empty_note": "With no rates configured you break out no tax at all.",
                  "taxes_prices_included": "Your menu prices already include the tax. Breaking it out does not change what your diner pays: the total is the same, and the receipt only shows how much of that total is tax.",
                  "taxes_rate_missing_name": "Name this rate or it will not be saved.",
                  "taxes_rate_name": "Name",
                  "taxes_rate_name_placeholder": "IVA",
                  "taxes_rate_percentage": "Percentage",
                  "taxes_rate_percentage_placeholder": "16",
                  "taxes_rates_hint": "The name is what your diner reads on the receipt. Leave both fields empty to remove a rate.",
                  "taxes_rates_label": "Rates",
                  "taxes_regime_label": "Regime",
                  "taxes_submit": "Save taxes",
                  "taxes_title": "Taxes",
                  "tips_description": "The percentages you suggest to your diners, and how what they leave is shared.",
                  "tips_distribution_hint": "Must add up to 100%%. The system calculates and reports; the policy is yours.",
                  "tips_distribution_invalid": "The two values must add up to 100%%.",
                  "tips_distribution_label": "Split",
                  "tips_distribution_shared": "Shared",
                  "tips_distribution_shared_hint": "Bar, kitchen, cashiers and host.",
                  "tips_distribution_waiters": "Waiters",
                  "tips_preview_label": "Your diners will see",
                  "tips_submit": "Save tips",
                  "tips_suggestions_hint": "Leave a field empty to drop that suggestion.",
                  "tips_suggestions_label": "Suggested percentages",
                  "tips_title": "Tips",
                  "tips_zero_note": "0%% is always shown and cannot be removed. Tipping is voluntary.",
                  "view_status_billing": "View billing status"
                },
                "show": {
                  "closed_now": "Closed",
                  "coordinates_present": "Set",
                  "copied": "Link copied.",
                  "copy": "Copy",
                  "edit": "Edit",
                  "edit_branch": "Edit branch",
                  "features_disabled": "Off · %{count}",
                  "features_empty": "No features are available for your restaurant yet.",
                  "features_enabled": "On · %{count}",
                  "hours_closed": "Closed",
                  "hours_disabled_note": "Hours are disabled, so orders can come in at any time.",
                  "hours_empty": "You have not set this branch's hours yet.",
                  "logo_missing": "Not uploaded",
                  "logo_present": "Uploaded",
                  "no_description": "You have not told diners anything about your restaurant yet.",
                  "no_schedule": "No schedule",
                  "not_set": "Not set",
                  "open_now": "Open now",
                  "opens_at": "Opens %{when}",
                  "page_description": "How this branch is set up today.",
                  "page_title": "Branch",
                  "profile_address": "Address",
                  "profile_city": "City",
                  "profile_coordinates": "Coordinates",
                  "profile_description": "Description",
                  "profile_logo": "Logo",
                  "profile_phone": "Phone",
                  "profile_title": "Profile",
                  "public_menu_no_slug": "You have not chosen your menu address yet.",
                  "public_menu_pending": "Pending",
                  "public_menu_published": "Published",
                  "public_menu_unpublished": "Unpublished",
                  "public_menu_view": "View menu",
                  "suspended": "This branch is operationally suspended. Diners cannot order.",
                  "taxes_added": "Tax is added on top of your menu prices.",
                  "taxes_configure": "Configure rates",
                  "taxes_included": "Your menu prices already include tax.",
                  "taxes_none": "No rates configured",
                  "taxes_none_hint": "Without rates you break out no tax: what your diner pays does not change, but the receipt does not say how much of that total is tax.",
                  "tips_diner_sees": "What your diner sees at checkout",
                  "tips_no_tip": "No tip",
                  "tips_shared": "Shared",
                  "tips_waiters": "Servers"
                }
              },
              "menu": {
                "index": {
                  "actions_category": "Category actions",
                  "add_category": "Add category",
                  "add_category_placeholder": "New category",
                  "add_extra": "Add extra",
                  "add_extra_group": "New group",
                  "add_item": "Add product",
                  "all_products": "All",
                  "categories_items_organized_section": "Organize your menu by categories and products.",
                  "categories_title": "Categories",
                  "category_emoji": "Category emoji",
                  "create_extra_group": "Create group",
                  "delete_category": "Delete category",
                  "delete_extra": "Delete extra",
                  "delete_extra_confirm": "This extra will be removed from the group. You can continue or cancel.",
                  "delete_extra_group": "Delete group",
                  "delete_extra_group_confirm": "This group and its extras will be removed. You can continue or cancel.",
                  "delete_item": "Delete product",
                  "delete_item_confirm": "This product will be removed from the menu. You can continue or cancel.",
                  "dish_count_one": "%{count} dish",
                  "dish_count_other": "%{count} dishes",
                  "edit_category": "Edit category",
                  "edit_extra_group_title": "Edit group",
                  "edit_item": "Edit product",
                  "edit_item_title": "Edit product",
                  "empty_category": "This category has no products yet. Add the first one.",
                  "extra_group_max_select": "Maximum selections (blank = unlimited)",
                  "extra_group_min_select": "Minimum selections",
                  "extra_group_min_select_warning": "A minimum of %{min} needs at least that many active extras — this group has %{count}. Diners see items as unavailable until you add more.",
                  "extra_group_name": "Name",
                  "extra_group_no_selection": "None",
                  "extra_group_status": "Status",
                  "extra_group_status_active": "Active",
                  "extra_group_status_inactive": "Inactive",
                  "extra_name_placeholder": "e.g. Green salsa",
                  "extra_price": "Price",
                  "extras_description": "Add-on groups customers can attach to products (e.g. sauces, cheese, toppings).",
                  "extras_title": "Extras",
                  "filter_sold_out": "Sold out",
                  "filter_without_description": "No description",
                  "filter_without_photo": "No photo",
                  "item_created": "Product created.",
                  "item_updated": "Product updated.",
                  "jump_to_new_category": "New category",
                  "management_menu": "Menu management",
                  "no_category": "Uncategorized",
                  "no_extra_groups_yet": "No extra groups yet. Create the first one to start offering add-ons.",
                  "no_extras_yet": "No extras yet.",
                  "no_menu_items": "No menu products yet. Create a category or add a product to get started.",
                  "no_results_hint": "Adjust the search or pick another category.",
                  "no_results_title": "No results",
                  "rename_category": "Rename category",
                  "search_placeholder": "Search a dish or category",
                  "sold_out_count_one": "%{count} sold out",
                  "sold_out_count_other": "%{count} sold out"
                }
              },
              "promotions": {
                "index": {
                  "description": "Standing price rules the system applies on its own, and the codes that trigger them.",
                  "title": "Promotions and coupons"
                }
              },
              "purchases": {
                "index": {
                  "description": "What you ordered from your suppliers. Stock moves when you receive.",
                  "title": "Purchases"
                },
                "new": {
                  "description": "Enter the supplies as they were invoiced. Quantities are in each supply's own unit.",
                  "title": "New purchase"
                }
              },
              "recipes": {
                "index": {
                  "description": "How much of each supply every dish and add-on uses. Without this nothing draws stock down.",
                  "title": "Recipes"
                }
              },
              "suppliers": {
                "index": {
                  "description": "Who you buy from. A supplier that already delivered is deactivated, never deleted.",
                  "title": "Suppliers"
                }
              },
              "supplies": {
                "index": {
                  "description": "What the kitchen consumes, how much there is, and what moved it.",
                  "title": "Inventory"
                },
                "show": {
                  "description": "Everything that moved this supply's balance, with its reason and who recorded it."
                }
              },
              "tables": {
                "edit": {
                  "back_tables": "Back to tables",
                  "edit_table": "Edit table",
                  "name": "Name",
                  "seats": "Seats",
                  "table": "Table 1",
                  "update_configuration_table": "Update the table settings."
                },
                "index": {
                  "add_table": "Add table",
                  "invite": "Invite",
                  "manage_tables_available_restaurant": "Manage your restaurant's available tables.",
                  "management_tables": "Table management",
                  "no_tables": "No tables registered. Create a table to get started.",
                  "printed_qr": "Printed QR",
                  "seats": "Seats",
                  "table_restaurant": "Restaurant table",
                  "tap_view_detail_table": "Tap to view table details"
                },
                "new": {
                  "cancel": "Cancel",
                  "create_table": "Create table",
                  "name": "Name",
                  "new_table": "New table",
                  "register_table_location_current": "Register a table for the current location.",
                  "seats": "Seats",
                  "status": "Status",
                  "table": "Table 1"
                },
                "show": {
                  "action_delete_table_location": "This action will delete the table from the current location. You can continue or cancel.",
                  "back_tables": "Back to tables",
                  "bills_active": "Active bills",
                  "cancel": "Cancel",
                  "delete": "Delete",
                  "delete_table": "Delete table",
                  "detail_operational_table": "Table operational details",
                  "download_qr": "Download QR",
                  "download_qr_failed": "We could not build the image. Reload the screen and try again.",
                  "download_qr_jpg": "JPG",
                  "download_qr_png": "PNG",
                  "download_qr_svg": "SVG (vector, prints at any size)",
                  "edit": "Edit",
                  "expires": "Expires",
                  "generate_invite": "Generate invite",
                  "generate_printed_qr": "Generate printed QR",
                  "invite_dynamic": "Dynamic invite",
                  "manage_access_qr_temporary_table": "Manage temporary QR access for this table.",
                  "no_active_invite": "There is no active invite for this table.",
                  "no_printed_qr": "This table has no printed QR yet.",
                  "printed_qr": "Table's printed QR",
                  "printed_qr_help": "Download it, print it and stick it on the table. It never expires — it works until you revoke it.",
                  "reuse_invite": "Reuse invite",
                  "revoke_invite": "Revoke invite",
                  "revoke_printed_qr": "Revoke printed QR",
                  "revoke_printed_qr_warning": "Revoking it stops the paper already on the table from working. You will have to print a new one.",
                  "seats": "Seats",
                  "status": "Status",
                  "table_restaurant": "Restaurant table",
                  "url_active": "Active URL",
                  "uses": "Uses"
                }
              },
              "tax_profile": {
                "show": {
                  "badge_incomplete": "Missing information",
                  "badge_ready": "Ready to invoice",
                  "defaults_description": "Optional. They are your accountant's answers and they travel on every invoice.",
                  "defaults_title": "Defaults",
                  "description": "Which RFC your restaurant invoices under, and which provider stamps for it.",
                  "empty_notice": "You have not entered your fiscal details yet. No invoice can be issued without them.",
                  "identity_description": "Exactly as it appears on your tax record. If anything differs, the SAT refuses the invoice.",
                  "identity_title": "Fiscal identity",
                  "legal_name_hint": "Without the capital regime. CFDI 4.0 wants it with no S.A. de C.V.",
                  "legal_name_label": "Legal name",
                  "pac_description": "Menny never holds your seal certificate. The seal is applied at your PAC, so all that lives here is the key we reach it with.",
                  "pac_environment_hint": "Leave it on sandbox until your accountant confirms the details.",
                  "pac_environment_label": "Environment",
                  "pac_key_configured": "Key configured",
                  "pac_key_hint": "Stored encrypted and never shown again. Leave it empty and the current key is untouched.",
                  "pac_key_label": "PAC key",
                  "pac_key_missing": "No key yet, so nothing can be stamped.",
                  "pac_key_placeholder_configured": "Leave empty to keep the key you already saved",
                  "pac_key_placeholder_empty": "Paste the key your provider gave you",
                  "pac_provider_label": "Provider",
                  "pac_provider_note": "Only the simulated provider exists today, so you can exercise the whole flow without spending stamps.",
                  "pac_title": "Stamping provider",
                  "postal_code_hint": "Your fiscal address. It is the place of issue on every invoice.",
                  "postal_code_label": "Postal code",
                  "product_code_hint": "ClaveProdServ. Without it we send 01010101, the SAT's generic code.",
                  "product_code_label": "Product or service code",
                  "rfc_hint": "12 characters for a company, 13 for a person.",
                  "rfc_label": "RFC",
                  "series_hint": "Your own numbering, if you use one.",
                  "series_label": "Series",
                  "submit": "Save fiscal details",
                  "submitting": "Saving…",
                  "tax_regime_label": "Tax regime",
                  "tax_regime_placeholder": "Choose your regime",
                  "title": "Fiscal details",
                  "unit_code_hint": "ClaveUnidad. Without it we send ACT, the SAT's generic unit.",
                  "unit_code_label": "Unit code"
                }
              },
              "users": {
                "edit": {
                  "edit_staff_member": "Edit staff member",
                  "update_identity_role_credentials_staff": "Update the staff member's identity, role, and credentials."
                },
                "index": {
                  "action_remove_access_staff_member": "This action will remove the staff member's access to the current location.",
                  "actions": "Actions",
                  "active_access_description": "Each record represents active access to this location.",
                  "add_staff": "Add staff",
                  "cancel": "Cancel",
                  "delete": "Delete",
                  "delete_staff_member": "Delete staff member",
                  "edit": "Edit",
                  "email": "Email",
                  "manage_staff_members_assigned_location": "Manage staff members assigned to the current location.",
                  "name": "Name",
                  "no_users": "No users assigned. Add the first staff member to get started.",
                  "role": "Role",
                  "staff": "Staff",
                  "team_current": "Current team"
                },
                "new": {
                  "create_access_staff_location_current": "Create staff access for the current location.",
                  "new_bill_staff": "New staff account"
                }
              }
            },
            "organization": {
              "branches": {
                "page_title": "Branches"
              },
              "members": {
                "page_title": "Members"
              },
              "nav": {
                "branches": "Branches",
                "label": "Organization sections",
                "members": "Members",
                "overview": "Overview",
                "settings": "Organization details"
              },
              "settings": {
                "address_title": "Address",
                "contact_title": "Contact",
                "fields": {
                  "address_line1": "Street and number",
                  "address_line2": "Unit, neighbourhood",
                  "city": "City",
                  "country": "Country",
                  "legal_business_name": "Legal business name",
                  "name": "Organization name",
                  "postal_code": "Postal code",
                  "rfc": "RFC",
                  "state": "State",
                  "support_email": "Contact email",
                  "support_phone": "Contact phone",
                  "tax_regime": "Tax regime"
                },
                "fiscal_note": "These details identify the organization. They are not used for stamping: each branch stamps with its own RFC, configured on its own tax details screen.",
                "fiscal_title": "Tax details",
                "identity_title": "Identity",
                "page_title": "Organization details",
                "save": "Save changes",
                "tax_regime_placeholder": "Choose a regime"
              },
              "show": {
                "average_hint": "Each branch's index is measured against this.",
                "average_label": "Average per branch",
                "branches_label": "Branches",
                "branches_title": "Branch by branch",
                "consolidated_label": "Consolidated",
                "current_branch": "you are here",
                "did_not_trade": "Did not open in the period",
                "index_value": "%{index}x the average",
                "members": {
                  "email_label": "Email address",
                  "email_placeholder": "partner@example.com",
                  "expires_on": "Expires on %{date}",
                  "invite": "Invite",
                  "pending_title": "Pending invitations",
                  "revoke": "Cancel the invitation for %{email}",
                  "role_label": "Access",
                  "title": "Organization members",
                  "you": "you"
                },
                "not_comparable": "Nothing to compare yet. Once two or more branches sell in the period, this shows how they stack up against each other.",
                "page_title": "Overview",
                "roster": {
                  "add_branch": "New branch",
                  "branch_count": {
                    "one": "%{count} branch",
                    "other": "%{count} branches"
                  },
                  "current": "you are here",
                  "member_count": {
                    "one": "%{count} member",
                    "other": "%{count} members"
                  },
                  "open": "Open",
                  "staff_count": {
                    "one": "%{count} on the team",
                    "other": "%{count} on the team"
                  },
                  "title": "Branches in the organization"
                },
                "row_meta": "%{transactions} payments · %{shifts} shifts",
                "title": "Organization comparison",
                "to_branch_report": "See this branch's report"
              }
            },
            "reports": {
              "show": {
                "actor_unknown": "Not recorded",
                "average_per_shift_label": "Average per shift",
                "average_ticket_label": "Average ticket",
                "bill_cancellations_title": "Cancelled bills",
                "busiest_hour_label": "Busiest hour",
                "by_day_chart_label": "Sales per service day",
                "by_day_title": "By day",
                "by_hour_chart_label": "Sales by hour on the restaurant's clock",
                "by_hour_hint": "Hours on your restaurant's clock.",
                "by_hour_title": "By hour",
                "by_method_title": "By payment method",
                "cancellations_count_label": "Cancellations",
                "cancellations_system_hint": "Lines still pending when the bill was closed. Nobody cancelled them.",
                "cancellations_system_label": "System",
                "cancellations_value_hint": "At menu price.",
                "cancellations_value_label": "Cancelled value",
                "capture_items_count": {
                  "one": "%{count} unit",
                  "other": "%{count} units"
                },
                "capture_role_unknown": "No role",
                "capture_self_service_meta": {
                  "one": "%{count} diner",
                  "other": "%{count} diners"
                },
                "capture_title": "Captured by",
                "chart_amount_column": "Sales",
                "chart_bucket_column": "Period",
                "chart_hour_column": "Hour",
                "chart_transactions_column": "Payments",
                "comparison_absent": "There is no earlier period to compare against.",
                "comparison_basis_average": "per shift, against the previous period",
                "comparison_basis_total": "against the previous period",
                "comparison_current": "Now %{amount} · %{shifts}",
                "comparison_new": "New",
                "comparison_previous": "Before %{amount} · %{shifts}",
                "control_clean": "No discounts, cancellations, refunds or reopenings in this period.",
                "control_scope": "Everything that moved money without being a sale, with who authorized it and why.",
                "control_title": "Control",
                "description": "Sales, product mix and control for the period.",
                "discounts_count_label": "Events",
                "discounts_non_revenue_hint": "Do not count as revenue.",
                "discounts_non_revenue_label": "Courtesies",
                "discounts_revenue_label": "Discounts",
                "discounts_title": "Discounts and courtesies",
                "empty_never_body": "The report is built from the till's cash-ups. As soon as you close your first shift you will see the period's sales here.",
                "empty_never_title": "Nothing to report yet",
                "empty_period_body": "The report is built from closed cash-ups. Try another period.",
                "empty_period_title": "No cash-ups in this period",
                "events_count": {
                  "one": "%{count} time",
                  "other": "%{count} times"
                },
                "mix_class_a": "A",
                "mix_class_b": "B",
                "mix_class_c": "C",
                "mix_cost_coverage": "Cost known for %{costed} of %{total} units.",
                "mix_item_margin": "Margin %{margin}",
                "mix_item_margin_unknown": "No recipe yet, so no cost",
                "mix_item_meta": "Class %{abc} · %{share} of the value",
                "mix_items_label": "Distinct dishes",
                "mix_margin_hint": "Ingredient cost %{ratio}",
                "mix_margin_label": "Margin",
                "mix_quantity_count": {
                  "one": "%{count} unit",
                  "other": "%{count} units"
                },
                "mix_quantity_label": "Units sold",
                "mix_show_all": {
                  "one": "Show %{count} more dish",
                  "other": "Show %{count} more dishes"
                },
                "mix_title": "Product mix",
                "mix_value_hint": "Not a sales total.",
                "mix_value_label": "Value of the dishes",
                "order_cancellations_title": "Cancelled lines",
                "orders_count": {
                  "one": "%{count} order",
                  "other": "%{count} orders"
                },
                "refund_rail_drawer": "Cash from the drawer",
                "refund_rail_provider": "Provider reversal",
                "refunds_count_label": "Refunds",
                "refunds_drawer_label": "From the drawer",
                "refunds_provider_label": "Through the terminal",
                "refunds_title": "Refunds",
                "reopenings_hint": "Reopening a closed bill moves no money by itself: it removes the lock that stops money moving.",
                "reopenings_title": "Reopened bills",
                "sales_scope": "This is the exact sum of the period's cash-ups. It covers dine-in, take-out and pickup; external channels are not included.",
                "sales_title": "Sales for the period",
                "sales_total_label": "Sales",
                "series_best_label": "Best day",
                "series_worst_label": "Slowest day",
                "shift_count": {
                  "one": "%{count} shift",
                  "other": "%{count} shifts"
                },
                "shifts_label": "Shifts",
                "tips_hint": "Not part of sales.",
                "tips_label": "Tips",
                "transactions_count": {
                  "one": "%{count} payment",
                  "other": "%{count} payments"
                },
                "transactions_label": "Payments"
              }
            },
            "reservations": {
              "index": {
                "add": "Book",
                "cancel": "Cancel",
                "cancel_back": "Back",
                "cancel_confirm": "Cancel reservation",
                "cancel_description": "The table frees up at that time as soon as you cancel.",
                "cancel_reason_label": "Reason",
                "cancel_reason_placeholder": "Pick a reason",
                "cancel_submitting": "Saving...",
                "cancel_title": "Cancel the reservation",
                "day_label": "Day",
                "empty": "No reservations for this day.",
                "ends_label": "To",
                "guest_label": "Under the name",
                "holding_count": "%{count} reservation(s) holding a table",
                "no_table": "No table",
                "page_description": "Who is coming today and to which table.",
                "page_title": "Reservations",
                "party_label": "People",
                "reason_cannot_host": "We cannot host them",
                "reason_guest_called": "The guest cancelled",
                "reason_no_show": "Did not show up",
                "row_meta": "%{time} · %{party} people",
                "seat": "Seat",
                "starts_label": "From",
                "table_label": "Table",
                "title": "The book"
              }
            },
            "shifts": {
              "show": {
                "amount_label": "Amount",
                "blocking_bills": {
                  "one": "%{count} bill is still unsettled. Collect it before closing the till.",
                  "other": "%{count} bills are still unsettled. Collect them before closing the till."
                },
                "cancellations_bills": "Cancelled bills",
                "cancellations_count": {
                  "one": "%{count} cancellation",
                  "other": "%{count} cancellations"
                },
                "cancellations_orders": "Cancelled items",
                "cancellations_title": "Cancellations",
                "cancellations_total": "Cancelled value",
                "cash_sales": "Cash sales",
                "close_cancel": "Cancel",
                "close_confirm": "Confirm close",
                "close_description": "Closing is final: this shift never reopens, and cash and terminal payments stay blocked until you open a new one.",
                "close_open": "Close till",
                "close_title": "Close the till",
                "closed_body": "Cash and card terminal payments need an open shift. Payments your guests make from the QR keep coming in and are recorded outside the shift.",
                "closed_by": "Closed by %{name} on %{time}.",
                "closed_title": "The till is closed",
                "declared_hint": "Count the whole drawer before confirming.",
                "declared_label": "Counted cash",
                "description": "Track the shift's cash and pull its cut.",
                "difference_balanced": "Balanced",
                "difference_label": "Difference",
                "difference_over": "Over",
                "difference_pending": "Enter the counted cash to see it.",
                "difference_short": "Short",
                "discounts_count": {
                  "one": "%{count} discount",
                  "other": "%{count} discounts"
                },
                "discounts_hint": "These amounts are already deducted from the payments above. They are named here so you can see where they went.",
                "discounts_non_revenue": "Courtesies and internal consumption",
                "discounts_revenue": "Discounts on sales",
                "discounts_title": "Discounts and courtesies",
                "duration_hours_minutes": "%{hours} h %{minutes} min",
                "duration_minutes": "%{minutes} min",
                "expected_cash": "Expected cash",
                "expected_cash_hint": "What the drawer should hold right now.",
                "journey_closes_in": "Closes in %{duration}",
                "journey_configure": "Set business hours",
                "journey_disabled_hint": "This location runs without fixed hours.",
                "journey_hours": "Business hours",
                "journey_not_configured_hint": "Nobody has written this location's hours down, so the register cannot tell you which day you are covering.",
                "journey_opens_in": "Opens in %{duration}",
                "journey_status_closed_today": "Closed today",
                "journey_status_disabled": "No fixed hours",
                "journey_status_not_configured": "No hours set",
                "journey_status_open": "Open",
                "journey_status_opens_later": "Not open yet",
                "journey_zone_hint": "Location time",
                "kind_label": "Type",
                "movement_submit": "Record movement",
                "movements_count": {
                  "one": "%{count} movement",
                  "other": "%{count} movements"
                },
                "movements_description": "Cash in and out that is not a sale: petty cash, supplier payments, bank deposits.",
                "movements_empty": "No movements recorded in this shift yet.",
                "movements_empty_closed": "This shift closed with no cash movements.",
                "movements_title": "Cash movements",
                "movements_total": "Movements",
                "never_opened_title": "You have not opened the till yet",
                "note_label": "Note",
                "note_placeholder": "Optional",
                "open_submit": "Open till",
                "open_submit_with_stock": "Open register and confirm stock",
                "open_title": "Shift open",
                "opened_by": "Opened by %{name}",
                "opening_float_hint": "Count the cash the drawer starts with.",
                "opening_float_label": "Opening float",
                "outside_shift_hint": "Payments your guests made from the QR with no shift open. They are not in the drawer and are not part of the totals above.",
                "outside_shift_title": "Collected outside the shift",
                "payment_methods_empty": "No payments recorded in this shift.",
                "payment_methods_title": "Payments by method",
                "payments_count": {
                  "one": "%{count} payment",
                  "other": "%{count} payments"
                },
                "previous_close_open_report": "View the full cut",
                "previous_close_report_title": "Previous shift cut",
                "previous_close_signed": "Closed by %{name} · %{time}",
                "previous_close_title": "How the register was left",
                "reason_label": "Reason",
                "refunds_count": {
                  "one": "%{count} refund",
                  "other": "%{count} refunds"
                },
                "refunds_drawer": "Returned from the drawer",
                "refunds_hint": "Whatever left the drawer is already in the movements. It is named here so you can see why the cash does not match the sales.",
                "refunds_provider": "Returned by the processor",
                "refunds_title": "Refunds",
                "report_scope": "This cut covers this shift only, not the whole day.",
                "report_title_closed": "Closed shift cut",
                "report_title_open": "Shift cut so far",
                "stock_alert_depleted": {
                  "one": "%{count} sold out",
                  "other": "%{count} sold out"
                },
                "stock_alert_low": {
                  "one": "%{count} running low",
                  "other": "%{count} running low"
                },
                "stock_closing_quantity": "Left at close: %{count}",
                "stock_confirm_all": "Confirm all as they are",
                "stock_confirm_row": "Confirm this dish",
                "stock_empty": "You are not counting any dish yet, so there is nothing to count in.",
                "stock_hint": "You start with whatever the last close left behind. Confirm each dish, or correct the number if you counted something else.",
                "stock_manage": "Manage stock",
                "stock_panel_counted": "Counted by %{name} · %{time}",
                "stock_panel_edited": {
                  "one": "%{count} corrected at opening",
                  "other": "%{count} corrected at opening"
                },
                "stock_panel_empty": "This location counts stock for no dish.",
                "stock_panel_hint": "Correct it right here if the kitchen restocked. The change saves on its own, without closing the shift.",
                "stock_panel_title": "Stock",
                "stock_panel_uncounted": "This shift was opened without a stock count.",
                "stock_pending": {
                  "one": "%{count} dish still to confirm.",
                  "other": "%{count} dishes still to confirm."
                },
                "stock_progress": "%{confirmed} of %{total} dishes confirmed",
                "stock_quantity_label": "%{name} stock",
                "stock_state_confirmed": "Confirmed",
                "stock_state_edited": "Edited",
                "stock_state_pending": "Pending",
                "stock_title": "Stock count",
                "stock_zero_hint": "A dish at 0 is not sold until you count stock for it.",
                "tax_missing_breakdown": {
                  "one": "%{count} payment with no tax breakdown.",
                  "other": "%{count} payments with no tax breakdown."
                },
                "tax_status_forward_regime": "This location charges tax on top of the menu price, so the cut does not break it down by rate.",
                "tax_status_itemized": "No taxed payments in this shift.",
                "tax_status_not_recorded": "This shift had payments, but none of them carries a tax breakdown.",
                "taxes_title": "Taxes",
                "title": "Till",
                "unknown_actor": "Not recorded"
              }
            }
          },
          "locations": {
            "index": {
              "create_location": "Create location",
              "create_location_comenzar_manage": "Create a location to start managing your operation.",
              "locations": "Your locations",
              "new_location": "New location",
              "no_tienes_locations": "You have no locations",
              "select_location_comenzar_work": "Select a location to start working."
            },
            "new": {
              "create_location": "Create location",
              "create_location_team_can": "Create a location so your team can operate.",
              "location_center": "Downtown Location",
              "name_restaurant": "Restaurant name",
              "new_location": "New location",
              "organization": "Group",
              "organization_hint": "This organization is what pays the branch's subscription."
            }
          },
          "organization_invites": {
            "show": {
              "accept": "Accept invitation",
              "as_account": "As %{email}.",
              "body": "%{inviter} invited you to %{organization}.",
              "body_no_inviter": "You have been invited to %{organization}.",
              "decline": "Decline",
              "expired": "This link no longer works. Ask whoever invited you to send a new one.",
              "grants": "Joining the organization lets you see the comparison across the branches you already work at. It does not grant access to a new branch; that is given separately.",
              "page_title": "Group invitation",
              "role": "Access: %{role}",
              "sign_out": "Sign out",
              "wrong_account": "This invitation is for %{email}. Sign out and sign in with that account to accept it."
            }
          },
          "organizations": {
            "new": {
              "billing_note": "Each organization is billed on its own. This one starts with no subscription, and its branches will not be able to open until you take one out.",
              "description": "An organization holds several branches under one billing account. It is billed separately from your other organizations.",
              "name_label": "Organization name",
              "name_placeholder": "Coast Group",
              "page_title": "New organization",
              "submit": "Create organization"
            }
          },
          "passwords": {
            "edit": {
              "back_to_sign_in": "Back to sign in",
              "choose_new_password": "Choose a new password",
              "confirm_new_password": "Confirm new password",
              "enter_new_password_twice": "Type your new password twice to confirm it",
              "new_password": "New password",
              "save_password": "Save password"
            },
            "new": {
              "back_to_sign_in": "Back to sign in",
              "email": "Email",
              "enter_email_send_instructions": "Enter your email and we will send you instructions to reset it",
              "forgot_password": "Forgot your password?",
              "m_ejemplo_com": "m@example.com",
              "send_instructions": "Send instructions"
            }
          },
          "registrations": {
            "new": {
              "already_tienes_bill": "Already have an account?",
              "card_description": "Takes less than a minute. We do not ask for a card.",
              "card_title": "Your account",
              "confirm_password": "Confirm Password",
              "continue_with_google": "Continue with Google",
              "email": "Email",
              "john_doe": "John Doe",
              "m_ejemplo_com": "m@example.com",
              "name": "Name",
              "next_hint": "Next: you name your restaurant.",
              "opens_note": "Your location opens on its own as soon as the first payment lands.",
              "or_with_email": "or with your email",
              "password": "Password",
              "proof_no_card_description": "Configure at your own pace. Payment is the last step on the list, and it is the one that opens the doors.",
              "proof_no_card_title": "No card to get started",
              "proof_price_description": "Plus VAT. No lock-in, and the whole product is included.",
              "proof_price_title": "%{amount} MXN per month per location",
              "proof_web_description": "It opens in the browser on a phone, a tablet or a computer. No hardware to buy.",
              "proof_web_title": "Nothing to install",
              "start_session": "Sign in",
              "step_account_description": "Your name, your email and a password. This account is how you sign in to Menny.",
              "step_account_now": "Now",
              "step_account_title": "Your account",
              "step_badge": "Step 1 of 2",
              "step_location_description": "Name it and it is created. From there you configure at your own pace.",
              "step_location_title": "Your restaurant",
              "submit": "Continue to my restaurant",
              "submit_processing": "Creating your account",
              "subtitle": "You start with your account. In the next step you name your restaurant and can begin building your menu, your tables and your payment methods.",
              "title": "Create your restaurant"
            }
          },
          "sessions": {
            "new": {
              "continue_with_google": "Continue with Google",
              "email": "Email",
              "forgot_password": "Forgot your password?",
              "m_ejemplo_com": "m@example.com",
              "no_tienes_bill": "Don't have an account?",
              "password": "Password",
              "register": "Sign Up",
              "sign_session_manage_restaurants": "Sign in to manage your restaurants",
              "start_session": "Sign In",
              "welcome_new": "Welcome back"
            }
          },
          "staff_invites": {
            "accept_btn": "Accept invitation and join",
            "decline_btn": "Ignore and create my own restaurant",
            "description": "You have a pending invitation to join a restaurant.",
            "hello": "Hello %{name}, you have been invited to join:",
            "title": "Invitation Received"
          }
        },
        "user": {
          "dashboards": {
            "show": {
              "create_bill": "Create bill",
              "order_pickup": "Order for pickup",
              "scan_code_qr_table": "Scan your table's QR code to start ordering, or continue as a guest to browse the menu.",
              "welcome_menny": "Welcome to Menny"
            }
          },
          "invites": {
            "ask": {
              "action": "Ask for the table to be opened",
              "explanation": "Your name reaches the restaurant and the people already at the table. It shows on the bill so they know who ordered what.",
              "label": "Your name",
              "placeholder": "Ana María",
              "title": "What's your name?"
            },
            "expired": {
              "body": "Your request expired. You can ask again.",
              "title": "Nobody answered in time"
            },
            "identify": {
              "action": "Join the table",
              "explanation": "Your name shows on the bill so your table knows who ordered what.",
              "label": "Your name",
              "placeholder": "Ana María",
              "title": "What's your name?"
            },
            "menu": {
              "ask_action": "Ask for the table to be opened",
              "ask_action_occupied": "Ask to join this table",
              "read_only_note": "You're viewing the menu. To order, ask for the table to be opened."
            },
            "refused": {
              "body": "Find someone from the restaurant so they can open the table for you.",
              "title": "Your entry was not approved"
            },
            "show": {
              "bill": "Bill #",
              "can_pay": "You can pay",
              "continue_menu": "Continue to menu",
              "continue_payment": "Continue to payment",
              "invite_invalid": "Invalid invite",
              "no_orders": "There are no orders on this bill yet."
            },
            "waiting": {
              "body": "As soon as someone confirms, you're in. Don't close this screen.",
              "title": "We let the restaurant know"
            }
          },
          "invoices": {
            "issued": {
              "delivery_note": "The restaurant delivers the XML and the PDF. If you need them now, show them this folio.",
              "folio": "Fiscal folio (UUID)",
              "legal_name": "Legal name",
              "pending_body": "We are generating it. It can take a few minutes; there is nothing for you to do.",
              "rfc": "RFC",
              "stamped_at": "Stamped on",
              "stamped_body": "It is stamped with the SAT. Keep the fiscal folio.",
              "title": "Your invoice"
            },
            "show": {
              "subtitle": "With your tax details, no account needed.",
              "title": "Invoice this bill"
            },
            "unavailable": {
              "body": "This link cannot be used to request an invoice. The deadline may have passed, the bill may already be invoiced, or the restaurant may not issue invoices yet. Ask the restaurant.",
              "title": "We cannot invoice this"
            }
          },
          "orders": {
            "index": {
              "not_yet_no_have_done": "You haven't placed any orders yet",
              "orders": "My orders",
              "this_visit": "What you ordered on this visit",
              "when_add_dishes_bill_appear": "When you add dishes to your bill, they'll appear here so you can track their status in real time."
            }
          },
          "passwords": {
            "edit": {
              "description": "Type it twice to confirm it.",
              "password": "Password",
              "password_confirmation": "Confirm password",
              "submit": "Save password",
              "title": "Choose your password"
            },
            "new": {
              "back_to_sign_in": "Back to sign in",
              "description": "Enter your email and we'll send you a link to create or reset your password.",
              "email": "Email",
              "email_placeholder": "m@example.com",
              "submit": "Send link",
              "title": "Get back into your account"
            }
          },
          "payment_methods": {
            "index": {
              "empty_hint": "Once you save a card it will appear here, so you don't have to enter it on every visit.",
              "empty_title": "You haven't saved a card yet",
              "title": "Payment methods"
            }
          },
          "profiles": {
            "settings": {
              "title": "Settings"
            }
          },
          "receipts": {
            "index": {
              "dine_in": "Dine-in",
              "empty_hint": "When you close your bill at a restaurant, that visit's receipt will appear here.",
              "empty_title": "You don't have any receipts yet",
              "items": {
                "one": "1 item",
                "other": "%{count} items"
              },
              "next": "Next",
              "page_of": "%{page} of %{total}",
              "pickup": "Pickup",
              "previous": "Previous",
              "title": "Receipts"
            }
          },
          "registrations": {
            "new": {
              "already_tienes_bill": "Already have an account?",
              "back_dashboard": "Back to dashboard",
              "confirm_password": "Confirm Password",
              "continue_with_google": "Continue with Google",
              "email": "Email",
              "john_doe": "John Doe",
              "m_ejemplo_com": "m@example.com",
              "name": "Name",
              "or": "or",
              "password": "Password",
              "register_with_email": "Sign up with email",
              "start_session": "Sign in"
            }
          },
          "sessions": {
            "new": {
              "continue_as_guest": "Continue as guest (dine-in)",
              "continue_with_google": "Continue with Google",
              "email": "Email",
              "enter_email_below_start_session": "Enter your email below to log in to your account",
              "flow_pickup_requires_bill_registered": "The pickup flow requires a registered bill.",
              "forgot_password": "Forgot your password?",
              "guest_continue": "Continue as guest",
              "guest_name_hint": "Your name shows on the bill so your table knows who ordered what.",
              "guest_name_label": "What's your name?",
              "guest_name_placeholder": "Ana María",
              "m_ejemplo_com": "m@example.com",
              "no_tienes_bill": "Don't have an account?",
              "password": "Password",
              "register": "Sign up",
              "start_session": "Log In",
              "welcome_new": "Welcome back"
            }
          }
        }
      }
    },
    "staff": {
      "cash_register": {
        "cancellation_reason_unspecified": "No reason recorded",
        "cancellation_scopes": {
          "bill": "Bill",
          "order": "Item"
        },
        "movement_kinds": {
          "cash_in": "Cash in",
          "cash_out": "Cash out"
        },
        "movement_reasons": {
          "bank_deposit": "Bank deposit",
          "correction": "Correction",
          "float_top_up": "Float top-up",
          "petty_cash": "Petty cash",
          "refund": "Refund",
          "supplier_payment": "Supplier payment"
        }
      },
      "locations": {
        "available": "Available location",
        "current": "Current location",
        "status": {
          "in_production": "In production",
          "pending_configuration": "Pending configuration",
          "suspended_billing": "Suspended for billing"
        },
        "use": "Use location",
        "using_current": "Using this location"
      },
      "orders": {
        "actions": {
          "cancel": "Cancel order",
          "complete": "Complete",
          "mark_ready": "Mark as ready",
          "no_show": "No-show",
          "picked_up": "Picked up",
          "ready_for_pickup": "Ready for pickup",
          "start_preparation": "Start preparation"
        },
        "add_to_order": "Add to order",
        "cart_title": "Order · %{count} %{item_label}",
        "create_order": "Create order",
        "create_order_count": "Create order (%{count})",
        "tap_item_to_add": "Tap a menu product to add it",
        "view_order": "View order",
        "view_order_count": "View order · %{count} %{item_label}"
      },
      "receipt_pdf": {
        "bill": "Bill #%{id}",
        "disclaimer": "This receipt is not a tax document. If you need an invoice, ask the restaurant and they will send you the link to generate it with your details.",
        "net": "Total after refunds",
        "payment_method": "Payment method",
        "phone": "Tel. %{number}",
        "refunds": "Refunds",
        "service_fee": "Service",
        "subtotal": "Subtotal",
        "table": "%{name}",
        "tax_id": "Tax ID %{rfc}",
        "tax_line": "%{name} %{rate}%%",
        "taxes_included": "Taxes included",
        "tip": "Tip",
        "title": "Receipt",
        "total": "Total"
      },
      "reports": {
        "actors": {
          "system": "Automatic bill closure",
          "unattributed": "No recorded owner"
        },
        "capture": {
          "self_service": "Self-service (QR)"
        },
        "charts": {
          "buckets": {
            "day": "per day",
            "month": "per month",
            "week": "per week"
          },
          "no_close": "no closes",
          "rolled_up": "Days are grouped %{bucket} so the series fits on screen. The exact per-day breakdown is still in the CSV.",
          "scope": "Each bar is %{bucket}."
        },
        "csv": {
          "columns": {
            "abc_class": "ABC class",
            "actor": "Owner",
            "amount": "Amount",
            "collected": "Collected",
            "concept": "Concept",
            "cost": "Ingredient cost",
            "count": "Count",
            "counts_as_revenue": "Counts as revenue",
            "cumulative_share": "Cumulative share",
            "date": "Date",
            "diner_fee": "Diner fee",
            "discount": "Discount",
            "gross": "Menu value",
            "hour": "Hour",
            "item": "Item",
            "items": "Units",
            "kind": "Kind",
            "lower": "Interval low",
            "margin": "Margin",
            "mean": "Estimate",
            "method": "Payment method",
            "net": "Net",
            "orders": "Orders",
            "quantity": "Units",
            "rail": "Rail",
            "reason": "Reason",
            "role": "Role",
            "share": "Share",
            "subtotal": "Subtotal",
            "system": "Automatic",
            "tip": "Tip",
            "upper": "Interval high",
            "value": "Value"
          },
          "rows": {
            "average_per_shift": "Average per shift",
            "average_ticket": "Average ticket",
            "busiest_hour": "Busiest hour",
            "cancellations_system": "Automatic cancellations on bill closure",
            "cancellations_total": "Total cancellations",
            "capture_total": "Total captured",
            "diner_fee": "Diner fee",
            "discounts_non_revenue": "Courtesies",
            "discounts_revenue": "Discounts that are still sales",
            "discounts_total": "Total discounts and courtesies",
            "ends_at": "End",
            "first_shift_ever": "Notice",
            "forecast_as_of": "Computed with data through",
            "forecast_attempts": "Attempts",
            "forecast_exhausted": "No more retries",
            "forecast_failed_at": "Failed at",
            "forecast_history_days": "History days",
            "forecast_history_shift_count": "Shifts in history",
            "forecast_horizon": "Horizon",
            "forecast_interval_width": "Interval width",
            "forecast_method": "Method",
            "forecast_pace_projected_service_days": "Projected service days",
            "forecast_pace_projected_subtotal": "Projection at current pace",
            "forecast_pace_remaining_days": "Days remaining",
            "forecast_pace_service_days": "Service days",
            "forecast_pace_subtotal": "Sales to date",
            "forecast_stale_by_days": "Days behind",
            "forecast_state": "Status",
            "growth_ratio": "Change",
            "mix_costed": "Units with a known cost",
            "mix_total": "Mix total",
            "normalize_on_average": "Notice",
            "per_shift_growth_ratio": "Change per shift",
            "period": "Period",
            "previous_period": "Previous period",
            "previous_shifts": "Previous period shifts",
            "previous_subtotal": "Previous period sales",
            "range": "Requested range",
            "refunds_drawer": "Drawer refunds",
            "refunds_provider": "Provider refunds",
            "refunds_total": "Total refunds",
            "reopenings_total": "Total reopenings",
            "shifts": "Shifts",
            "starts_at": "Start",
            "subtotal": "Sales",
            "time_zone": "Time zone",
            "tip": "Tips",
            "transactions": "Transactions",
            "truncated": "Notice"
          },
          "sections": {
            "bill_cancellations": "Bill cancellations",
            "by_day": "Sales by day",
            "by_hour": "Sales by hour",
            "by_method": "Sales by payment method",
            "capture": "Captured by",
            "discounts": "Discounts and courtesies",
            "forecast": "Sales forecast",
            "mix": "Product mix",
            "order_cancellations": "Line cancellations",
            "refunds": "Refunds",
            "reopenings": "Bill reopenings",
            "sales": "Sales",
            "summary": "Period summary"
          }
        },
        "export": "Download CSV",
        "forecast": {
          "chart_actual_label": "Actual",
          "chart_band": "Band: %{lower} – %{upper}",
          "chart_date_column": "Date",
          "chart_expected_label": "Estimate",
          "chart_label": "Actual and estimated sales",
          "chart_lower_column": "Interval low",
          "chart_note": "Actual shifts on the left, estimate on the right · based on %{history_days} days of history (%{shifts} shifts).",
          "chart_seam_label": "Today",
          "chart_upper_column": "Interval high",
          "hero_hint": "Band: %{lower} – %{upper}",
          "hero_label": "Horizon estimate",
          "horizons": {
            "day": "%{count} days",
            "week": "%{count} weeks"
          },
          "method": {
            "prophet": "statistical model",
            "weekday_seasonal": "weekday median"
          },
          "pace": {
            "hint": "%{service_days} of %{projected_service_days} service days · %{remaining_days} days left in the period",
            "projected_label": "Projection at current pace",
            "subtotal_label": "Sales to date",
            "title": "Current period pace"
          },
          "provenance": "Estimated with %{method}, using data through %{as_of} · %{interval} confidence band.",
          "states": {
            "failed": {
              "one": "The forecast failed %{count} time. It will retry automatically.",
              "other": "The forecast failed %{count} times. It will retry automatically."
            },
            "failed_exhausted": {
              "one": "The forecast failed %{count} time and will not retry again.",
              "other": "The forecast failed %{count} times and will not retry again."
            },
            "pending": "We're calculating the forecast. This can take a few minutes.",
            "stale": {
              "one": "The forecast is stale: the latest data is from %{as_of}, %{count} day ago.",
              "other": "The forecast is stale: the latest data is from %{as_of}, %{count} days ago."
            },
            "unavailable": "Not enough history yet to generate a forecast."
          },
          "title": "Sales forecast"
        },
        "notes": {
          "capture_basis": "Who captured the order, not who served it. It does not match the sales total.",
          "control_not_deducted": "These figures are not deducted from sales. Sales are already net of discounts.",
          "external_channels": "Does not include Uber Eats, Rappi or DiDi Food orders.",
          "first_shift_ever": "This is the location's first period, so it starts at the beginning of the first shift's day rather than at an earlier close.",
          "former": "No longer works here",
          "mix_basis": "Menu value of the dishes sold. It does not match the sales total because it is computed over order lines rather than over payments.",
          "normalize_on_average": "The two periods hold a different number of shifts, so the comparison is shown per shift."
        },
        "period": {
          "empty": "No shifts have been closed in this period yet",
          "notes": {
            "truncated": "This range holds more than %{count} closed shifts. We are showing the %{count} most recent ones; split the range into shorter stretches to see the rest."
          },
          "shift_count": {
            "one": "%{count} shift",
            "other": "%{count} shifts"
          },
          "span": "From the %{from} close to the %{to} close · %{shifts}",
          "span_first": "From the start of the day on %{from} to the %{to} close · %{shifts}"
        },
        "presets": {
          "custom": "Custom",
          "last_30_shifts": "Last 30 shifts",
          "last_90_days": "Last 90 days",
          "month": "This month",
          "quarter": "This quarter",
          "today": "Today",
          "week": "This week",
          "yesterday": "Yesterday"
        },
        "range": {
          "apply": "Apply",
          "from": "From",
          "hint": "Up to %{days} days. Future dates cannot be selected.",
          "invalid": "Check the dates: the end cannot come before the start.",
          "label": "From %{from} to %{to}",
          "title": "Custom range",
          "to": "To",
          "too_long": "The range cannot exceed %{days} days. Shorten the dates."
        },
        "reopen_reason_unspecified": "No reason recorded",
        "title": "Reports"
      },
      "stats": {
        "bucket_field": "Range",
        "buckets": {
          "day": "a day",
          "month": "a month",
          "week": "a week"
        },
        "closed_buckets": {
          "day": {
            "one": "%{count} closed day",
            "other": "%{count} closed days"
          },
          "month": {
            "one": "%{count} closed month",
            "other": "%{count} closed months"
          },
          "week": {
            "one": "%{count} closed week",
            "other": "%{count} closed weeks"
          }
        },
        "description": "How the business is doing over time. The per-shift close still lives in Reports.",
        "empty": {
          "no_data_body": "Try a longer range.",
          "no_data_title": "This range has no closed shifts",
          "no_shifts_body": "Statistics are built from closed shifts. Open and close the register and the first point shows up at the next close.",
          "no_shifts_title": "Nothing to chart yet"
        },
        "hour_map": {
          "less": "less",
          "more": "more",
          "no_sales": "no sales",
          "peak": "Peak hour",
          "peak_none": "—",
          "title": "When the restaurant sells"
        },
        "kpi": {
          "average_ticket": "Average ticket",
          "food_cost": "Food cost %{ratio}",
          "margin": "Gross margin",
          "net_sales": "Net sales",
          "new": "new",
          "normalized": "per-shift delta: the two windows do not bracket the same number of shifts",
          "per_bucket": "%{amount} per point",
          "transactions": "Orders",
          "versus": "vs %{amount}"
        },
        "leaks": {
          "bill_cancellations": "Cancelled bills",
          "count": {
            "one": "%{count} event",
            "other": "%{count} events"
          },
          "discounts": "Discounts",
          "no_amount": "no amount",
          "order_cancellations": "Cancelled orders",
          "refunds": "Refunds",
          "reopenings": "Bill reopenings",
          "share": "%{share} of sales",
          "title": "Leaks"
        },
        "mix": {
          "class_a": "Class A",
          "class_b": "Class B",
          "class_c": "Class C",
          "class_count": {
            "one": "%{count} dish",
            "other": "%{count} dishes"
          },
          "item_margin": "margin %{margin}",
          "item_margin_unknown": "no recipe, no cost yet",
          "item_meta": "%{abc} · %{share} of the mix",
          "quantity": {
            "one": "%{count} sold",
            "other": "%{count} sold"
          },
          "share_of_value": "%{share} of value",
          "show_all": "Show the remaining %{count}",
          "title": "Which dishes carry the menu"
        },
        "notes": {
          "cost_coverage": "%{costed} of %{total} dishes sold have a recipe. Margin is computed over those alone.",
          "hour_map_basis": "Sales by hour and day over the whole window. This is the map rosters are built from.",
          "hour_map_thin": "A short window is a thin basis for staffing: one payday or one long weekend moves a whole band.",
          "leaks_basis": "The percentage is over the window's net sales. Who and why lives in Reports.",
          "mix_basis": "ABC classification over the value of the dishes sold. It does not match net sales, and it must not: this counts dishes, that counts payments.",
          "open_bucket": "The point in progress is drawn dotted and enters no comparison.",
          "same_weekday": "In days the comparison is still against the same number of preceding shifts: 30 days already contain whole weeks."
        },
        "ranges": {
          "days30": "30 days",
          "months12": "12 months",
          "weeks12": "12 weeks",
          "weeks26": "6 months",
          "years": "By year"
        },
        "scope": "%{label} · %{buckets} · point = %{bucket}",
        "series": {
          "average": "Average per point",
          "best": "Best point",
          "open": "in progress",
          "title": "Net sales per point",
          "worst": "Weakest point"
        },
        "title": "Statistics"
      },
      "tables": {
        "active_invite": "Active",
        "alerts": {
          "awaiting_release": "Settled table still needs clearing",
          "entry_requested": "Someone is waiting to be let in",
          "payment_pending": "Payment stalled at the table",
          "ready_unserved": "Dish ready but not served",
          "waiter_requested": "A diner asked for a waiter"
        },
        "canceling": "Canceling…",
        "closing_bill": "Closing…",
        "delete_category_confirm": "Are you sure you want to delete this category?",
        "no_invite": "No invite",
        "no_static_invite": "No printed QR",
        "order_count": "%{count} %{order_label}",
        "static_invite": "Printed"
      },
      "users": {
        "create_member": "Create member",
        "create_password_help": "Password is required for new accounts and optional when reactivating deleted access.",
        "edit_password_help": "Leave the password empty if you do not want to change it.",
        "manager_email_help": "Managers need an explicit email to receive account access and recovery.",
        "non_manager_email_help": "For non-manager roles, we generate an internal email automatically to satisfy validations.",
        "password_label_create": "Password",
        "password_label_edit": "New password"
      }
    },
    "tables": {
      "actions": {
        "add_order": "Add order",
        "add_order_legacy": "Add order",
        "disable": "Disable",
        "invite": "Invite",
        "occupy": "Occupy",
        "release": "Release",
        "reserve": "Reserve"
      },
      "bills_count": "%{count} bills",
      "sessions_count": "%{count} sessions"
    },
    "user": {
      "ask_for_more": "Ask for water or something else",
      "back_to_menu": "Back to menu",
      "call_waiter": "Call waiter",
      "common": {
        "me": "Me",
        "people_count": {
          "one": "%{count} person",
          "other": "%{count} people"
        },
        "products_count": {
          "one": "%{count} product",
          "other": "%{count} products"
        },
        "table_label": "Table %{name}",
        "waiter": "Waiter"
      },
      "confirmations": {
        "resend": "Resend confirmation email",
        "sending": "Sending…"
      },
      "dish": {
        "add": "Add",
        "free": "Free",
        "mine_caption": "You pay for it",
        "no_active_table": "No active table",
        "no_extra": "None",
        "required": "Required",
        "share_caption": "Split with everyone",
        "unavailable": "Unavailable",
        "unavailable_reason": "This item is temporarily unavailable."
      },
      "home": {
        "all_menu": "Full menu",
        "at_table": "At table %{name}",
        "default_menu": "Menu",
        "demo_mode": "Demo mode",
        "greeting": "Hi there! 👋",
        "self_name": "you",
        "uncategorized": "Other"
      },
      "invite_state": {
        "bill_closed": "The selected bill was closed. You can create a new bill."
      },
      "invites": {
        "continue_order": "You can continue with your order.",
        "process_failed": "The invite could not be processed.",
        "welcome": "Welcome to %{name}"
      },
      "no_customization": "No customization",
      "only_mine": "Only mine",
      "pay_in_cashier": "Pay at cashier",
      "payment_received": "Payment received!",
      "registrations": {
        "complete_registration": "Complete your registration",
        "create_account": "Create an account",
        "create_description": "Enter your details to register on the platform",
        "submit_complete": "Complete registration",
        "submit_create": "Sign up",
        "upgrade_description": "Convert your guest session into a registered account."
      },
      "show_qr_to_waiter": "Show QR to the waiter",
      "tracking": {
        "active": "In progress",
        "cancelled": "Cancelled",
        "cancelled_status": "%{name} cancelled",
        "done": "Completed",
        "pending": "Pending",
        "preparing_status": "%{name} in preparation",
        "ready_status": "%{name} ready"
      },
      "tracking_stages": {
        "confirmed": "Confirmed",
        "in_progress": "In preparation",
        "ready": "Ready at table",
        "received": "Order received"
      },
      "waiter_call": {
        "call": "Call the waiter",
        "calling": "Calling…",
        "cancel_action": "Yes, cancel it",
        "cancel_body": "We'll let the restaurant know you no longer need attention.",
        "cancel_title": "Cancel the call?",
        "cancelling": "Cancelling…",
        "confirm_action": "Yes, call",
        "confirm_body": "We'll let the floor know someone should come over.",
        "confirm_title": "Call the waiter?",
        "dismiss": "Never mind",
        "pending_action": "A waiter is on the way. Tap to cancel the call."
      }
    }
  }
}
